import React, { forwardRef, useEffect, useRef, useImperativeHandle, useState } from 'react';
import './questionSurveyForm.scss';
import { Picker, List, InputItem, TextareaItem, Modal, Toast, Radio, DatePickerView, ActivityIndicator, Tabs, Checkbox, Badge, Icon } from 'antd-mobile';
import { ImageViewer, TextArea } from 'antd-mobile-v5';
import ImgCanvas from '../image-canvas/drawCanvas.jsx';
import formGoFill from '../../static/icon/formGoFill.svg';
import formGoPhoto from '../../static/icon/formGoPhoto.svg';
import close from '../../static/icon/close.svg';
import noCollected from '../../static/icon/noCollected.svg';
import saveBtn from '../../static/icon/saveBtn.svg';
import create_question from '../../static/icon/create_question.svg';
import answer_question from '../../static/icon/answer_question.svg';
import answer_question_2 from '../../static/icon/answer_question_2.svg';
import close_question from '../../static/icon/close_question.svg';
import close_question_2 from '../../static/icon/close_question_2.svg';
import question_modify from '../../static/icon/question_modify.svg';
import IconAnswer from '../../static/icon/icon_answer.png';
import IconAnswerReply from '../../static/icon/icon_answer_reply.png';
import moment, { now } from 'moment';
import { ApiCore } from '../../api';
import { createFromIconfontCN } from '@ant-design/icons';
import { PhotoSlider } from 'react-photo-view';
import 'react-photo-view/dist/index.css';
import axios from 'axios';
import verify from '../../utils/verify';
import ImagePicker from '../image-picker/index';
import Video from '../video/index';
import FileComponent from '../file/index';
import tool from '../../utils/tool';
import more from '../../static/icon/more.svg';
import { any, filter } from 'bluebird';
import { Radio as V5Radio, Space } from 'antd-mobile-v5'
import mExper from "./utils/operation.ts";
import styles from '../image-picker/styles';

import styless from './questionSurveyForm.module.scss';

import OSS from "ali-oss";

const api = new ApiCore();
const RadioItem = Radio.RadioItem;
const CheckboxItem = Checkbox.CheckboxItem;
let photoId = 0;
let isFirstDesensitizate = true;
let isEditPhoto = false; // useState update replaced
let isOcr = false;
const matchUrlSensitive = {}; // 匹配敏感信息

let timerId;
let otherTimeout: any = null;

//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: [
        '//at.alicdn.com/t/font_2323742_xvjwsudf76n.js',
        '//at.alicdn.com/t/font_2857469_i2b7j58rf1.js'
    ],
});
function QuestionSurveyForm(props: any, ref: any) {
    //设置加载状态
    const [loading, setLoading] = useState(false);
    //当前表单的id
    const [formId, setFormId] = useState<any>();
    //设置表单域
    const [fieldList, setFieldList] = useState<any>([]);

    //是否显示填写表单的模态框
    const [showModal, setShowModal] = useState(false);

    //点击选中的表单元素
    const [selectField, setSelectField] = useState<any>();

    //选中的填写表单的备注类型
    const [selectNoteType, setSelectNoteType] = useState<any>();

    //当前tabs的索引
    const [currentTabIndex, setCurrentTabIndex] = useState<number>(0);

    //当前表单的值
    const [currentValue, setCurrentValue] = useState<any>();

    //当前表单的值
    const [isOnClickSelect, setIsOnClickSelect] = useState<boolean>(false);

    //当前表单已存的value
    const [savedValue, setSavedValue] = useState<any>([]);

    //当前表单的info
    const [currentFormInfo, setCurrentFormInfo] = useState<any>([]);

    //当前整个表单的dataAction
    const [dataAction, setDataAction] = useState<any>([]);

    //整个表单的formAction
    const [formActions, setFormActions] = useState<any>([]);

    //表单是否可读状态
    const [formIsRead, setFormIsRead] = useState(true);

    //注释类型
    const [annotationType, setAnnotationType] = useState<any>([]);

    //当前选中的注解值
    const [annotationValue, setAnnotationValue] = useState<any>();

    //当前选中的备注值
    const [remarkValue, setRemarkValue] = useState<any>();

    //检查类型
    const [questionType, setQuestionType] = useState<any>([]);

    //当前选择的检查类型
    const [selectQuestionType, setSelectQuestionType] = useState<any>();

    //检查说明
    const [questionInf, setQuestionInf] = useState<any>();

    //当前选中的表单的数据质疑列表
    const [selectFieldQuestion, setSelectFieldQuestion] = useState<any>([]);

    //当前选中的question item的id
    const [selectQuestionItemId, setSelectQuestionItemId] = useState<any>();

    //回复质疑的操作类型
    const [answerQuestionType, setAnswerQuestionType] = useState<any>([]);

    //当前选中的质疑操作类型
    const [currentQuestionType, setCurrentQuestionType] = useState<any>();

    //补充说明
    const [supplementInf, setSupplementInf] = useState<any>();
    //修改值
    const [questionModifyValue, setQuestionModifyValue] = useState<any>();
    //数据稽查
    const [traceList, setTraceList] = useState<any>([]);
    //图片
    const [photos, setPhotos] = useState<any>([]);
    //上传成功的图片list
    const [uploadedPhotoList, setUploadedPhotoList] = useState<any>([]);
    //图片预览是否显示
    const [photoVisible, setPhotoVisible] = useState(false);
    //当前预览图片的index
    const [currentPhotoIndex, setCurrentPhotoIndex] = useState<any>(0);
    //是否需要重新上传图片后载提交
    const [ifReUpload, setIfReUpload] = useState<boolean>(false);
    //当有其他选项的值
    const [otherValue, setOtherValue] = useState<any>();
    //图片上传状态
    const [uploadState, setUploadState] = useState<boolean>(false);
    //input-select数据值
    const [inputValue, setInputValue] = useState<any>('');
    const [selectValue, setSelectValue] = useState<any>('');
    //输入error
    const [inputError, setInputError] = useState<boolean>(false);
    // 设置当前显示的图片示例
    const [currPhotoRemark, setCurrPhotoRemark] = useState<string>('');
    // 设置图片是否可以脱敏
    const [infoPhotos, setInfoPhotos] = useState<any>([]);
    // 是否可以脱敏
    const [ifEditPhoto, setEditPhoto] = useState<any>();
    // 
    const [sensitiveData, setSensitiveData] = useState<any>([]);

    const [formCode] = useState<any>(props.formCode);

    const [version] = useState<any>(props.version);
    // 是否需要OCR识别显示
    const [needOcrRecongize, setOcrRecongize] = useState<boolean>(false);
    // 保存上传后需要提交的数据
    const [formUpdateParams, setFormUpdateParams] = useState<any>({});

    // 显隐按钮文字
    const [nextText, setNextText] = useState<any>('下一题');
    // 必填项是否为空
    let isNullValidationIs = false;
    // 获取OSS访问令牌
    const [ossData, setOssData] = useState<any>({});
    // 视频
    const [videos, setVideos] = useState<any>([]);
    //上传成功的视频list
    const [uploadedVideoList, setUploadedVideoList] = useState<any>([]);
    // 文件
    const [filesData, setFilesData] = useState<any>([]);
    //上传成功的文件list
    const [uploadedFileList, setUploadedFileList] = useState<any>([]);

    //视频上传进度
    const [vedioProgress, setVedioProgress] = useState<any>([null]);
    //视频文件
    const [vedioFile, setVideoFile] = useState<any>(null);

    // 进来的项目
    const _itemData = {
        projectCode: '',
        subjectCode: ''
    };
    let itemData = sessionStorage.getItem('toPhotoEditItem');
    itemData = itemData ? JSON.parse(itemData) : _itemData;
    let mRef = useRef();
    const mPhotoRef = useRef();
    const mVideoRef = useRef();
    const mFileRef = useRef();
    // 新属性-编辑状态
    const editModel = sessionStorage.getItem('editModel');
    useEffect(() => {
        // 进入
        isFirstDesensitizate = true;
        getOssData()
        return () => {
            //  销毁
            isFirstDesensitizate = false;
            clearTimeout(otherTimeout);
        }
    }, [])

    useEffect(() => {
        if (currentValue !== undefined && isOnClickSelect) {
            // console.log('currentValue改变')
            setIsOnClickSelect(false);
            // 已提交的onUpdate()，未提交的onSave()
            if (props.fieldList.formActions && props.fieldList.formActions.length == 0) {
                onUpdate()
            } else {
                onSave()
            }
        }
    }, [currentValue])

    useEffect(() => {
        if (props.formId) {
            setFormId(props.formId);
        }
        //初始化数据
        initData(props.fieldList);


    }, [props])

    const isDesensitizateProject = () => {
        if (!isFirstDesensitizate) {
            return;
        }
        isFirstDesensitizate = false;
        api.isDesensitizateProject({
            // @ts-ignore 
            projectCode: itemData.projectCode
        }).then(res => {
            if (res.code + '' == '0') {
                // 是否需要脱敏 0：否 1：是
                isEditPhoto = !!(res.data && res.data.isDesensitization);
                isOcr = !!(res.data && res.data.isOcr);
                // setEditPhoto(true); // 暂时不用，更新有问题
            } else {
                isEditPhoto = false;
                isOcr = false;
                // setEditPhoto(false);
            }
            setEditPhoto(isEditPhoto);
        })
    }

    //初始数据处理
    const initData = (data: any) => {
        // return;
        if (data) {
            props.readonly != true && isDesensitizateProject(); // 请求是否脱敏状态
            tool.dealFieldList(data);
            tool.dealFieldListByValues(data);
            let formValues = data.values;
            let fieldList = data.body;
            // 初始化选项数据
            fieldList = fieldList.map((value: any) => {
                const _children = value.children.map((val: any) => {
                    const _childrenChild = val.children.map((v: any) => {
                        let _selectedValue: any = null;
                        let _selectedOtherValue: any = null;
                        val.children.some((vv: any) => {
                            if (vv.display) {
                                if ((vv.display.target === v.deCode) || (vv.display.target === v.dataCode)) {
                                    v.displayTarget = vv;
                                    return true; // 终止
                                }
                            }
                        });
                        // 其他选项设置
                        formValues.some((item: any) => {
                            if ((item.deCode === v.deCode) || (item.dataCode === v.dataCode)) {
                                if (item.value) {
                                    // 一般选项
                                    _selectedValue = item;
                                }
                            }
                            if (v.displayTarget && v.displayTarget.display && v.displayTarget.display.type === 'ValueCascade') {
                                if ((v.displayTarget.deCode === item.deCode) || (v.displayTarget.dataCode === item.dataCode)) {
                                    _selectedOtherValue = item;
                                }
                            }
                        });

                        return {
                            ...v,
                            selectedValue: _selectedValue,
                            selectedOtherValue: _selectedOtherValue
                        }
                    });
                    return {
                        ...val,
                        children: _childrenChild
                    };
                });
                return {
                    ...value,
                    children: _children
                }
            })
            // 过滤掉其他选项请注明
            fieldList = fieldList.map((value: any) => {
                const _children = value.children.map((val: any) => {
                    const _childrenChild = val.children.filter((v: any) => {
                        if (v.display && v.display.type === 'ValueCascade') {
                            return false;
                        } else {
                            return true;
                        }
                    });
                    return {
                        ...val,
                        children: _childrenChild
                    };
                });
                return {
                    ...value,
                    children: _children
                }
            });
            let savedValue = data.values;
            let dataAction = data.dataActions;
            let formAction = data.formActions;
            //dataAction
            if (dataAction && dataAction.length > 0) {
                let tabs = [];
                for (let item of dataAction) {
                    if (item == 'DataActionRead') {
                        tabs.push({
                            label: '数据值',
                            key: 'DataActionRead',
                        })
                    }
                    else if (item == 'DataActionRemarkRead') {
                        tabs.push({
                            label: '备注',
                            key: 'DataActionRemarkRead',
                        })
                    }
                    else if (item == 'DataActionAnnotationRead') {
                        tabs.push({
                            label: '注释',
                            key: 'DataActionAnnotationRead',
                        })
                    }
                    else if (item == 'DataActionInput') {
                        tabs.push({
                            label: '录入',
                            key: 'DataActionInput',
                        })
                    }
                    else if (item == 'DataActionUpdate') {
                        tabs.push({
                            label: '修改',
                            key: 'DataActionUpdate',
                        })
                    }
                    else if (item == 'DataActionRemark') {
                        tabs.push({
                            label: '备注',
                            key: 'DataActionRemark',
                        })
                    }
                    else if (item == 'DataActionAnnotation') {
                        tabs.push({
                            label: '注释',
                            key: 'DataActionAnnotation',
                        })
                    }
                    else if (item == 'DataActionQuestion') {
                        tabs.push({
                            label: '质疑',
                            key: 'DataActionQuestion',
                        })
                    }
                    else if (item == 'DataActionAnswer') {
                        tabs.push({
                            label: '回复质疑',
                            key: 'DataActionAnswer',
                        })
                    }
                    else if (item == 'DataActionTrace') {
                        tabs.push({
                            label: '痕迹稽查',
                            key: 'DataActionTrace',
                        })
                    }
                }
                //设置tabs
                setDataAction(tabs);
                //默认选中第一个tab
                setSelectNoteType(dataAction[0]);
                //根据选中的第一个值进行处理
                switch (dataAction[0]) {
                    //注释
                    case 'DataActionAnnotation':
                        setLoading(true);
                        api.getAnnotationType().then(res => {
                            if (res.code == '0') {
                                setAnnotationType(res.data)
                            }
                            setLoading(false);
                        })
                        break;
                    //注释只读
                    case 'DataActionAnnotationRead':
                        setLoading(true);
                        api.getAnnotationType().then(res => {
                            if (res.code == '0') {
                                setAnnotationType(res.data)
                            }
                            setLoading(false);
                        })
                        break;
                    //创建/关闭质疑
                    case 'DataActionQuestion':
                        setLoading(true);
                        api.getQuestionTypes().then(res => {
                            if (res.code == '0') {
                                if (res.data && res.data.length > 0) {
                                    let filterArr = [];
                                    for (let item of res.data) {
                                        filterArr.push(
                                            {
                                                label: item.text,
                                                value: item.key
                                            }
                                        )
                                    }
                                    setQuestionType(filterArr)
                                }
                            }
                            setLoading(false);
                        })
                        break;
                    //回复质疑
                    case 'DataActionAnswer':
                        let answerType = [
                            {
                                label: '保留原值',
                                value: 'Retain'
                            },
                            {
                                label: '修改原值',
                                value: 'Update'
                            },
                            {
                                label: '置空原值',
                                value: 'Empty'
                            }
                        ]
                        //回复的类型
                        setAnswerQuestionType(answerType);
                        setCurrentQuestionType(answerType[0].value);
                        break;
                    //数据稽查
                    case 'DataActionTrace':
                        let params = {
                            formId: formId,
                            dataCode: selectField.dataCode,
                        }
                        setLoading(true);
                        api.getTrance(params).then(res => {
                            if (res.code == '0') {
                                setTraceList(res.data)
                            }
                            else {
                                setTraceList([])
                            }
                            setLoading(false);
                        })
                        break;
                    default:
                        break;
                }
            }

            //判断表单是否处于可读状态
            if (formAction && formAction.length > 0) {
                if (formAction.includes('FormActionRead')) {
                    setFormIsRead(false);
                }
            }

            if (dataAction && dataAction.length == 0) {
                setFormIsRead(false);
            }

            setFieldList(fieldList);
            setSavedValue(savedValue);
            setFormActions(formAction);

            logicOperation(fieldList, savedValue);
        }
    }

    // 设置选中的值
    const updateFormValue = (item: any, changedValue: any, changedOtherValue: any) => {
        let _fieldList = fieldList;
        let _savedValue = savedValue;
        _fieldList = fieldList.map((value: any) => {
            const _children = value.children.map((val: any) => {
                const _childrenChild = val.children.map((v: any) => {
                    let _selectedValue: any = null;
                    let _selectedOtherValue: any = null;
                    // if (item.dataCode === v.dataCode) {
                    // 此时dataCode没有？
                    if (changedValue && item.deCode === v.deCode) {
                        _selectedValue = {
                            value: changedValue
                        }
                    }
                    if (changedOtherValue && item.deCode === v.deCode) {
                        _selectedOtherValue = {
                            ...v.selectedOtherValue,
                            value: changedOtherValue
                        }
                    }
                    return {
                        ...v,
                        selectedValue: _selectedValue || v.selectedValue || null,
                        selectedOtherValue: _selectedOtherValue || v.selectedOtherValue || null
                    }
                });
                return {
                    ...val,
                    children: _childrenChild
                };
            });
            return {
                ...value,
                children: _children
            }
        })
        _savedValue = _savedValue.map((savedV: any) => {
            if (savedV.deCode === item.deCode) {
                return {
                    ...savedV,
                    dataCode: savedV.dataCode || savedV.deCode,
                    deCode: savedV.dataCode || savedV.deCode,
                    value: changedValue
                };
            }
            return {
                ...savedV,
                dataCode: savedV.dataCode || savedV.deCode,
                deCode: savedV.dataCode || savedV.deCode
            };
        });
        setFieldList(_fieldList);
        setSavedValue(_savedValue);
        // 更新选中表单数据
        // changedValue && api.updateData({ formId: formId, dataCode: item.deCode, deCode: item.deCode, value: changedValue });
        if (changedValue) {
            api.saveForm({
                formId: formId, submit: false, values: [{
                    deCode: item.deCode || item.dataCode, dataCode: item.dataCode || item.deCode, value: changedValue
                }]
            }).then((res: any) => {
                if (res.code == 0) {
                    // 更新后的所有savedValue
                    setSavedValue(res.data || []);
                }
            });
        }
        // 更新其他选项表单数据
        if (changedOtherValue) {
            const _selectedOtherValue = item.selectedOtherValue || {};
            const _otherTargetValue = item.displayTarget || {};
            clearTimeout(otherTimeout);
            otherTimeout = setTimeout(() => {
                api.saveForm({
                    formId: formId, submit: false, values: [{
                        deCode: (_selectedOtherValue.deCode || _selectedOtherValue.dataCode) || (_otherTargetValue.deCode || _otherTargetValue.dataCode),
                        dataCode: (_selectedOtherValue.dataCode || _selectedOtherValue.deCode) || (_otherTargetValue.deCode || _otherTargetValue.dataCode), value: changedOtherValue
                    }]
                }).then((res: any) => {
                    if (res.code == 0) {
                        // 更新后的所有savedValue
                        setSavedValue(res.data || []);
                    }
                });;
            }, 2000);
        }
    }

    const logicOperation = (fieldList: any, savedValue: any) => {
        if (!fieldList || fieldList.length == 0 || !savedValue || savedValue.length == 0) {
            return;
        }
        for (let field of fieldList) {
            if (field.logicOperations && field.logicOperations.length > 0) {
                for (let logicOperation of field.logicOperations) {
                    mExper.handleLogicOperations(logicOperation, savedValue, field);
                }
            }
            if (field["children"]) {
                logicOperation(field["children"], savedValue);
            }
        }
    }

    //根据formId更新当前表单状态
    const getDataById = () => {
        let params = {
            id: formId
        }
        api.getFormTemplateById(params).then(res => {
            if (res.code == '0' && res.data) {
                //初始化数据
                initData(res.data);
            }
        })
    }

    useImperativeHandle(ref, () => ({
        // changeVal 就是暴露给父组件的方法
        getSavedForm: () => {
            let formData = {
                formId: formId,
                submit: true,
                values: savedValue
            }
            return formData
        },
        // 相同大小视频处理
        dealSameVideo,
        vedioFile,
    }));

    const showPhotoRemark = (item: any) => {
        return () => {
            setCurrPhotoRemark(item["link"]);
        }
    }

    // 获取敏感信息
    const getSensitiveData = (imgUrl: any) => {
        return new Promise<void>((resolve, reject) => {
            api.GetOcrSensitiveRecord({
                imgUrl: imgUrl
            }).then(res => {
                if ((res.code + '') === '0') {
                    res.data && setSensitiveData(res.data);
                    res.data && res.data.forEach((item: any, index: any) => {
                        if (item.coordinate && (item.coordinate.length > 0)) {
                            matchUrlSensitive[item.imgId] = item.imgId;
                        }
                        resolve();
                        // @ts-ignore
                        // _imgUrl.forEach((val, index) => {
                        //     if (val.indexOf(item.imgId) >= 0) {
                        //         matchUrlSensitive[index] = item.imgId;
                        //     }
                        // })
                    })
                }
            });
        })
    }

    //点击表单进行填写表单
    const fillFormBtn = (item: any) => {

        return () => {
            if (props.readonly) {
                return;
            }
            if (formIsRead) {
                //设置当前选中的action类型
                setSelectNoteType(dataAction[0].key)
                //设置tab索引
                setCurrentTabIndex(0);
                //设置弹框是否显示
                setShowModal(true)
                //设置当前选中的表单
                setSelectField(item);
                //清除输入error
                setInputError(false);
                //当前选中表单已存的value
                let currentItem = savedValue.find((i: any) => {
                    return i.dataCode == item.dataCode
                });
                if (currentItem) {
                    //当类型为photo时设置图片地址
                    if (item.type === 'photo'|| item.type === 'photo-oss') {
                        if (currentItem.value) {
                            let filterArr: any = [];
                            let _imgUrl: any = [];
                            for (let photoItem of currentItem.value) {
                                filterArr.push(
                                    {
                                        url: photoItem
                                    }
                                )
                                _imgUrl.push(photoItem);
                            }
                            let suffixPhotos = changedPhoto(filterArr);
                            setPhotos(suffixPhotos);
                            //设置已经保存的图片
                            setUploadedPhotoList(currentItem.value);
                            //设置当前值
                            setCurrentValue(currentItem.value)
                            //设置注解信息
                            setAnnotationValue(currentItem.annotation)
                            //设置备注信息
                            setRemarkValue(currentItem.remark)
                            //设置已存在的质疑
                            setSelectFieldQuestion(currentItem.questions)
                            // 获取敏感信息
                            getSensitiveData(_imgUrl).then(() => {
                                setInfoPhotos(getInfoTipPhoto(suffixPhotos));
                            });
                        }
                        else {
                            setCurrentValue(null);
                            setPhotos([]);
                            setInfoPhotos([]);
                            setUploadedPhotoList([]);
                            //设置注解信息
                            setAnnotationValue(currentItem.annotation)
                            //设置备注信息
                            setRemarkValue(currentItem.remark)
                            //设置已存在的质疑
                            setSelectFieldQuestion(currentItem.questions)
                        }
                    }
                    //当类型为video时设置视频地址
                    else if (item.type === 'video') {
                        if (currentItem.value) {
                            let filterArr: any = [];
                            let _videoUrl: any = [];
                            for (let videoItem of currentItem.value) {
                                filterArr.push(
                                    {
                                        url: videoItem
                                    }
                                )
                                _videoUrl.push(videoItem);
                            }
                            let suffixVideos = changedPhoto(filterArr);
                            setVideos(suffixVideos);
                            //设置已经保存的视频
                            setUploadedVideoList(currentItem.value);
                            //设置当前值
                            setCurrentValue(currentItem.value)
                            //设置注解信息
                            setAnnotationValue(currentItem.annotation)
                            //设置备注信息
                            setRemarkValue(currentItem.remark)
                        }
                        else {
                            setCurrentValue(null);
                            setVideos([]);
                            setUploadedVideoList([]);
                            //设置注解信息
                            setAnnotationValue(currentItem.annotation)
                            //设置备注信息
                            setRemarkValue(currentItem.remark)
                        }
                    }
                    //当类型为video时设置文件地址
                    else if (item.type === 'file') {
                        if (currentItem.value) {
                            let filterArr: any = [];
                            let _fileUrl: any = [];
                            for (let fileItem of currentItem.value) {
                                filterArr.push(
                                    {
                                        url: fileItem
                                    }
                                )
                                _fileUrl.push(fileItem);
                            }
                            let suffixFiles = changedPhoto(filterArr);
                            setFilesData(suffixFiles);
                            //设置已经保存的文件
                            setUploadedFileList(currentItem.value);
                            //设置当前值
                            setCurrentValue(currentItem.value)
                            //设置注解信息
                            setAnnotationValue(currentItem.annotation)
                            //设置备注信息
                            setRemarkValue(currentItem.remark)
                        }
                        else {
                            setCurrentValue(null);
                            setFilesData([]);
                            setUploadedFileList([]);
                            //设置注解信息
                            setAnnotationValue(currentItem.annotation)
                            //设置备注信息
                            setRemarkValue(currentItem.remark)
                        }
                    }
                    else if (item.type === 'checkbox') {
                        if (currentItem.value) {
                            if (item.other) {
                                if (currentItem.value.indexOf(item.other.key) !== -1) {
                                    setOtherValue(currentItem.value[currentItem.value.length - 1]);
                                    let filterCurrentValue = [];
                                    for (let i = 0; i < currentItem.value.length - 1; i++) {
                                        filterCurrentValue.push(currentItem.value[i])
                                    }
                                    setCurrentValue([...filterCurrentValue])
                                }
                                else {
                                    setOtherValue('');
                                    setCurrentValue([...currentItem.value])
                                }
                            }
                            else {
                                // 设置当前值
                                setCurrentValue([...currentItem.value])
                            }
                            //设置注解信息
                            setAnnotationValue(currentItem.annotation)
                            //设置备注信息
                            setRemarkValue(currentItem.remark)
                            //设置已存在的质疑
                            setSelectFieldQuestion(currentItem.questions)
                        }
                        else {
                            setCurrentValue(Array(Object.keys(item.optional).length).fill(''));
                            //设置注解信息
                            setAnnotationValue(currentItem.annotation)
                            //设置备注信息
                            setRemarkValue(currentItem.remark)
                            //设置已存在的质疑
                            setSelectFieldQuestion(currentItem.questions)
                        }
                    }
                    else if (item.type === 'input-select') {
                        if (currentItem.value) {
                            let filterArr = currentItem.value;
                            if (filterArr && filterArr.length === 2) {
                                if (item.other) {
                                    if (item.optional[filterArr[1]]) {
                                        setInputValue(filterArr[0]);
                                        setSelectValue(filterArr[1]);
                                        setOtherValue('');
                                    }
                                    else {
                                        setSelectValue(item.other.key);
                                        setInputValue(filterArr[0]);
                                        setOtherValue(filterArr[1]);
                                    }
                                }
                                else {
                                    setInputValue(filterArr[0]);
                                    setSelectValue(filterArr[1]);
                                    setOtherValue('');
                                }
                                //设置注解信息
                                setAnnotationValue(currentItem.annotation)
                                //设置备注信息
                                setRemarkValue(currentItem.remark)
                                //设置已存在的质疑
                                setSelectFieldQuestion(currentItem.questions)
                            }
                        }
                        else {
                            setInputValue('');
                            setSelectValue('');
                            setOtherValue('');
                            //设置注解信息
                            setAnnotationValue(currentItem.annotation)
                            //设置备注信息
                            setRemarkValue(currentItem.remark)
                            //设置已存在的质疑
                            setSelectFieldQuestion(currentItem.questions)
                        }
                    }
                    else if (item.type === 'date') {
                        if (currentItem.value) {
                            //设置当前值
                            setCurrentValue(currentItem.value)
                            //设置注解信息
                            setAnnotationValue(currentItem.annotation)
                            //设置备注信息
                            setRemarkValue(currentItem.remark)
                            //设置已存在的质疑
                            setSelectFieldQuestion(currentItem.questions)
                        }
                        else {
                            setCurrentValue(new Date())
                            //设置注解信息
                            setAnnotationValue(currentItem.annotation)
                            //设置备注信息
                            setRemarkValue(currentItem.remark)
                            //设置已存在的质疑
                            setSelectFieldQuestion(currentItem.questions)
                        }
                    }
                    else if (item.type === 'select') {
                        if (currentItem.value) {
                            if (item.other) {
                                if (item.optional[currentItem.value]) {
                                    //设置当前值
                                    setCurrentValue(currentItem.value);
                                    //设置其他值
                                    setOtherValue(null);
                                }
                                else {
                                    //设置当前值
                                    setCurrentValue(item.other.key);
                                    //设置其他值
                                    setOtherValue(currentItem.value)
                                }
                            }
                            else {
                                //设置当前值
                                setCurrentValue(currentItem.value)
                                //设置其他值
                                setOtherValue(null);
                            }
                            //设置注解信息
                            setAnnotationValue(currentItem.annotation)
                            //设置备注信息
                            setRemarkValue(currentItem.remark)
                            //设置已存在的质疑
                            setSelectFieldQuestion(currentItem.questions)
                        }
                        else {
                            setCurrentValue(item.defaultValue)
                            setOtherValue(null);
                            //设置注解信息
                            setAnnotationValue(currentItem.annotation)
                            //设置备注信息
                            setRemarkValue(currentItem.remark)
                            //设置已存在的质疑
                            setSelectFieldQuestion(currentItem.questions)
                        }
                    }
                    else {
                        if (currentItem.value) {
                            //设置当前值
                            setCurrentValue(currentItem.value)
                            //设置注解信息
                            setAnnotationValue(currentItem.annotation)
                            //设置备注信息
                            setRemarkValue(currentItem.remark)
                            //设置已存在的质疑
                            setSelectFieldQuestion(currentItem.questions)
                        }
                        else {
                            setCurrentValue(null);
                            //设置注解信息
                            setAnnotationValue(currentItem.annotation)
                            //设置备注信息
                            setRemarkValue(currentItem.remark)
                            //设置已存在的质疑
                            setSelectFieldQuestion(currentItem.questions)
                        }
                    }
                }
                else {

                    if (item.type === 'select') {
                        setCurrentValue(item.defaultValue)
                    }
                    else if (item.type === 'date') {
                        setCurrentValue(new Date())
                    }
                    else if (item.type === 'checkbox') {
                        setCurrentValue(Array(Object.keys(item.optional).length).fill(''));
                    }
                    else {
                        setCurrentValue(null);
                        setInputValue('');
                        setSelectValue('');
                        setPhotos([]);
                        setInfoPhotos([]);
                        setUploadedPhotoList([]);
                    }
                    // 重置备注
                    setRemarkValue(null)
                    setSelectFieldQuestion(null)
                    //重置注释
                    setAnnotationValue(null)
                }
                //重置质疑相关数据
                setSelectQuestionType(null);
                setQuestionInf(null);
            }
            else {
                Toast.fail('当前表单为可读状态', 1)
            }
        }
    }

    //当选择的tab发生变化
    const onChangeTab = (tab: any, index: number) => {
        setCurrentTabIndex(index);
        let type = tab.key
        setSelectNoteType(type);
        switch (type) {
            //注释
            case 'DataActionAnnotation':
                setLoading(true);
                api.getAnnotationType().then(res => {
                    if (res.code == '0') {
                        setAnnotationType(res.data)
                    }
                    setLoading(false);
                })
                break;
            //注释只读
            case 'DataActionAnnotationRead':
                setLoading(true);
                api.getAnnotationType().then(res => {
                    if (res.code == '0') {
                        setAnnotationType(res.data)
                    }
                    setLoading(false);
                })
                break;
            //创建/关闭质疑
            case 'DataActionQuestion':
                setLoading(true);
                api.getQuestionTypes().then(res => {
                    if (res.code == '0') {
                        if (res.data && res.data.length > 0) {
                            let filterArr = [];
                            for (let item of res.data) {
                                filterArr.push(
                                    {
                                        label: item.text,
                                        value: item.key
                                    }
                                )
                            }
                            setQuestionType(filterArr)
                        }
                    }
                    setLoading(false);
                })
                break;
            //回复质疑
            case 'DataActionAnswer':
                let answerType = [
                    {
                        label: '保留原值',
                        value: 'Retain'
                    },
                    {
                        label: '修改原值',
                        value: 'Update'
                    },
                    {
                        label: '置空原值',
                        value: 'Empty'
                    }
                ]
                //回复的类型
                setAnswerQuestionType(answerType);
                setCurrentQuestionType(answerType[0].value);
                break;
            //数据稽查
            case 'DataActionTrace':
                let params = {
                    formId: formId,
                    dataCode: selectField.dataCode,
                }
                setLoading(true);
                api.getTrance(params).then(res => {
                    if (res.code == '0') {
                        setTraceList(res.data)
                    }
                    else {
                        setTraceList([])
                    }
                    setLoading(false);
                })
                break;
            default:
                break;
        }
    }

    //当关闭模态框
    const onCloseModal = () => {
        setShowModal(false);
        setSelectField(null);
        setCurrentValue(null);
    }

    //验证是否为空
    const validationIsNull = (item: any) => {
        //检查是否必须选项
        if (item.validationRules && item.validationRules.length > 0 && props.readonly != true) {
            let isNotNull = false;
            for (let rule of item.validationRules) {
                if (rule.condition === 'ne' && rule.rule === 'null') {
                    return (
                        <span className="necessary">*</span>
                    )
                }
                else {
                    return null
                }
            }
        }
    }

    //动态显示已经保存的值
    const showSavedValue = (item: any) => {
        let currentItem = savedValue.find((i: any) => {
            return i.dataCode === item.dataCode
        });
        if (currentItem) {
            if (item.type === 'select') {
                if (currentItem.value) {
                    if (item.optional[currentItem.value]) {
                        return item.optional[currentItem.value]
                    }
                    else if (item.other) {
                        if (item.other.type === 'input') {
                            return currentItem.value;
                        }
                        else if (item.other.type === 'date') {
                            return moment(currentItem.value).format('YYYY-MM-DD')
                        }
                    }
                    else {
                        return null;
                    }
                }
            }
            else if (item.type === 'date') {
                if (currentItem.value) {
                    return moment(currentItem.value).format('YYYY-MM-DD')
                }
            }
            else if (item.type === 'checkbox') {

                if (currentItem.value) {
                    let filterArr = [];
                    for (let i of currentItem.value) {
                        if (i) {
                            if (item.other) {
                                if (i !== item.other.key) {
                                    if (item.optional[i]) {
                                        filterArr.push(item.optional[i]);
                                    }
                                }
                            }
                            else {
                                if (item.optional[i]) {
                                    filterArr.push(item.optional[i]);
                                }
                            }
                        }
                    }
                    if (item.other) {
                        if (currentItem.value.indexOf(item.other.key) !== -1) {
                            filterArr.push(currentItem.value[currentItem.value.length - 1])
                        }
                    }
                    return filterArr.join(',')
                }
            }
            else if (item.type === 'photo'|| item.type === 'photo-oss') {
                if (currentItem.value && currentItem.value.length > 0) {
                    return props.readonly ? '' : '图片已上传，点击查看'
                }
                else {
                    return ''
                }
            }
            else if (item.type === 'video') {
                if (currentItem.value && currentItem.value.length > 0) {
                    return props.readonly ? '' : '视频已上传，点击查看'
                }
                else {
                    return ''
                }
            }
            else if (item.type === 'file') {
                if (currentItem.value && currentItem.value.length > 0) {
                    return props.readonly ? '文件已上传' : '文件已上传，点击查看'
                }
                else {
                    return ''
                }
            }
            else if (item.type === 'input-select') {
                if (currentItem.value) {
                    let value;
                    if (item.other) {
                        if (item.optional[currentItem.value[1]]) {
                            value = `${currentItem.value[0]}${item.optional[currentItem.value[1]]}`;
                        }
                        else {
                            if (item.other.type === 'input') {
                                value = `${currentItem.value[0]}${currentItem.value[1]}`;
                            }
                            else if (item.other.type === 'date') {
                                value = `${currentItem.value[0]}${moment(currentItem.value[1]).format('YYYY-MM-DD')}`;
                            }
                        }
                        return value
                    } else {
                        value = `${currentItem.value[0]}${item.optional[currentItem.value[1]]}`;
                        return value
                    }
                }
            }
            else {
                if (currentItem.value) {
                    return item.unit ? `${currentItem.value}${item.unit}` : currentItem.value
                }
            }
        }
        else {
            if (item.type === 'select') {
                if (item.defaultValue) {
                    return item.optional[item.defaultValue]
                }
            }
            else {
                return null;
            }
        }
    }

    //select的点击事件
    const onClickSelect = (value: any) => {

        return () => {
            setIsOnClickSelect(true);
            setCurrentValue(value);
        }
    }

    //checkbox的点击事件
    const onClickCheckbox = (value: any) => {
        return () => {
            // con
            // console.log('onClickCheckbox-value:',value)
            let filterArr = currentValue;
            if (filterArr) {
                let i = filterArr.indexOf(value);
                if (i !== -1) {
                    filterArr.splice(i, 1, '');
                }
                else {
                    for (let i = 0; i < Object.keys(selectField.optional).length; i++) {
                        if (Object.keys(selectField.optional)[i] === value) {
                            // filterArr.splice(i, 1, value)
                            filterArr.push(value)
                        }
                    }
                }
            }

            if (selectField.validationRules) {
                selectField.validationRules.forEach((item: { type: string; condition: string; rule: any; }, index: any) => {
                    if (item.type === 'logic') {
                        if (item.condition === 'mutex') {
                            //当前的value在rule数组中的index
                            let arrIndex: any;
                            item.rule.forEach((ruleItem: string | any[], ruleItemIndex: any) => {
                                if (ruleItem.indexOf(value) !== -1) {
                                    arrIndex = ruleItemIndex;
                                }
                            })
                            if (arrIndex !== undefined) {
                                item.rule.forEach((ruleItem: any[], ruleItemIndex: any) => {
                                    if (ruleItemIndex !== arrIndex) {
                                        ruleItem.forEach((key: any) => {
                                            let i = filterArr?.indexOf(key) || -1;
                                            if (i !== -1) {
                                                filterArr[i] = '';
                                            }
                                        })
                                    }
                                })
                            }
                        }
                    }
                })
            }
            setCurrentValue(Object.assign([], filterArr || [value]));
        }
    }

    //暂存数据
    const onSave = () => {

        // console.log('onSave-selectField:',selectField,',onSave-currentValue:',currentValue,',onSave-otherValue:',otherValue)
        if (!inputError && selectField) {

            if (selectField.type === 'input-select') {
                //选了其他
                if (selectField.other && selectValue.indexOf(selectField.other.key) !== -1) {
                    if (inputValue && otherValue) {
                        let value: any;
                        //自动补零
                        if (inputValue.indexOf(".") !== -1) {
                            if (inputValue.indexOf(".") === inputValue.length - 1) {
                                setInputValue(inputValue + '0');
                                value = [{
                                    dataCode: selectField.dataCode,
                                    deCode: selectField.deCode,
                                    value: [inputValue + '0', otherValue],
                                }];
                            } else {
                                value = [{
                                    dataCode: selectField.dataCode,
                                    deCode: selectField.deCode,
                                    value: [inputValue, otherValue],
                                }];
                            }
                        }
                        else {
                            value = [{
                                dataCode: selectField.dataCode,
                                deCode: selectField.deCode,
                                value: [inputValue, otherValue],
                            }];
                        }

                        let params = {
                            formId: formId,
                            submit: false,
                            values: [...value]
                        }
                        setLoading(true);
                        api.saveForm(params).then(res => {
                            if (res.code == '0') {
                                let filterArr = res.data;
                                setSavedValue(filterArr)
                                setShowModal(false);
                                setSelectField(null);
                                setCurrentValue(null);
                            }
                            else {
                                Toast.fail(res.message, 1);
                            }
                            props.updateData();
                            setLoading(false);
                        })
                    }
                    else {
                        Toast.fail('请填写完整后再试！', 1);
                        isNullValidationIs = true
                    }

                } else {
                    if (inputValue && selectValue) {
                        let value: any;
                        //自动补零
                        if (inputValue.indexOf(".") !== -1) {
                            if (inputValue.indexOf(".") === inputValue.length - 1) {
                                setInputValue(inputValue + '0');
                                value = [{
                                    dataCode: selectField.dataCode,
                                    deCode: selectField.deCode,
                                    value: [inputValue + '0', selectValue],
                                }];
                            } else {
                                value = [{
                                    dataCode: selectField.dataCode,
                                    deCode: selectField.deCode,
                                    value: [inputValue, selectValue],
                                }];
                            }
                        }
                        else {
                            value = [{
                                dataCode: selectField.dataCode,
                                deCode: selectField.deCode,
                                value: [inputValue, selectValue],
                            }];
                        }

                        let params = {
                            formId: formId,
                            submit: false,
                            values: [...value]
                        }
                        setLoading(true);
                        api.saveForm(params).then(res => {
                            if (res.code == '0') {
                                let filterArr = res.data;
                                setSavedValue(filterArr)
                                setShowModal(false);
                                setSelectField(null);
                                setCurrentValue(null);
                            }
                            else {
                                Toast.fail(res.message, 1);
                            }
                            props.updateData();
                            setLoading(false);
                        })
                    }
                    else {
                        Toast.fail('请填写完整后再试！', 1);
                        isNullValidationIs = true
                    }
                }
            }
            else if (selectField.type === 'checkbox') {

                let value: any[] = [];
                let validation = true;
                //若包含other字段
                /* if (selectField.other) {
                    let filterValue;
                    if (currentValue && currentValue.indexOf(selectField.other.key) !== -1) {
                        if (otherValue) {
                            filterValue = currentValue.concat(otherValue.trim());
                        }
                        else {
                            filterValue = currentValue;
                        }
                    }
                    else {
                        filterValue = currentValue;
                    }
                    value = [{
                        dataCode: selectField.dataCode,
                        deCode: selectField.deCode,
                        value: filterValue,
                    }];
                }
                else {
                    value = [{
                        dataCode: selectField.dataCode,
                        deCode: selectField.deCode,
                        value: currentValue,
                    }];
                } */
                value = [{
                    dataCode: selectField.dataCode,
                    deCode: selectField.deCode,
                    value: (currentValue && currentValue.length > 0) ? currentValue.filter((item: any) => {
                        return item !== '' && item !== null && item !== undefined
                    }) : [],
                }];
                if (selectField.other) {
                    if (currentValue && currentValue.indexOf(selectField.other.key) !== -1) {
                        if (otherValue) {
                            value[0].value.concat(otherValue.trim());
                        }
                    }
                }

                /* let judgeNullArr = JSON.parse(JSON.stringify(value[0].value)) || [];
                for (let i = 0; i < judgeNullArr.length; i++) {
                    if (judgeNullArr[i] === '' || judgeNullArr[i] === null || judgeNullArr[i] === undefined) {
                        judgeNullArr.splice(i, 1)
                        i = i - 1;
                    }
                } */
                if (validationIsNull(selectField)) {
                    if (value[0].value && value[0].value.length > 0) {
                        if (selectField.other) {
                            if (value[0].value && value[0].value.indexOf(selectField.other.key) !== -1) {
                                if (otherValue && otherValue.trim()) {
                                    validation = true;
                                }
                                else {
                                    validation = false;
                                }
                            }
                        }
                        else {
                            validation = true;
                        }
                    } else {
                        validation = false;
                    }
                }

                if (validation) {
                    let params = {
                        formId: formId,
                        submit: false,
                        values: [...value]
                    }
                    setLoading(true);
                    api.saveForm(params).then(res => {
                        if (res.code == '0') {
                            let filterArr = res.data;
                            setSavedValue(filterArr)
                            setShowModal(false);
                            setSelectField(null);
                            setCurrentValue(null);
                        }
                        else {
                            Toast.fail(res.message, 1);
                        }
                        props.updateData();
                        setLoading(false);
                    })
                }
                else {
                    console.log('请填写完整后再试！')
                    Toast.fail('请填写完整后再试！', 1);
                    isNullValidationIs = true
                }
            }
            else if (selectField.type === 'select') {
                let value: any[] = [];
                let validation = true;
                //若包含other字段
                if (selectField.other) {
                    let filterValue;
                    if (currentValue && currentValue.indexOf(selectField.other.key) !== -1) {
                        if (selectField.other.type === 'input') {
                            if (otherValue && otherValue.trim()) {
                                filterValue = otherValue.trim();
                                validation = true;
                            }
                            else {
                                validation = false;
                            }
                        }
                        else if (selectField.other.type === 'date') {
                            if (otherValue) {
                                filterValue = otherValue;
                                validation = true;
                            }
                            else {
                                validation = true;
                                filterValue = new Date();
                            }
                        }
                    }
                    else {
                        filterValue = currentValue;
                        validation = true;
                    }
                    value = [{
                        dataCode: selectField.dataCode,
                        deCode: selectField.deCode,
                        value: filterValue,
                    }];
                }
                else {
                    value = [{
                        dataCode: selectField.dataCode,
                        deCode: selectField.deCode,
                        value: currentValue,
                    }];
                }

                if (validation) {
                    let params = {
                        formId: formId,
                        submit: false,
                        values: [...value]
                    }
                    setLoading(true);
                    api.saveForm(params).then(res => {
                        if (res.code == '0') {
                            let filterArr = res.data;
                            setSavedValue(filterArr)
                            setShowModal(false);
                            setSelectField(null);
                            setCurrentValue(null);
                        }
                        else {
                            Toast.fail(res.message, 1);
                        }
                        props.updateData();
                        setLoading(false);
                    })
                }
                else {
                    Toast.fail('请填写完整后再试！', 1);
                    isNullValidationIs = true
                }
            }
            else {

                if (selectField.type == 'number' || selectField.type == 'decimal') {
                    let judge = verify.checkValueByRange(currentValue, selectField)

                    if (!judge) {
                        return false
                    }
                }

                let value: any[] = [];
                let validation = true;
                //自动补零
                if (typeof currentValue === 'string' && currentValue.indexOf(".") !== -1) {
                    if (currentValue.indexOf(".") === currentValue.length - 1) {
                        setCurrentValue(currentValue + '0');
                        value = [{
                            dataCode: selectField.dataCode,
                            deCode: selectField.deCode,
                            value: currentValue + '0',
                        }];
                    } else {
                        value = [{
                            dataCode: selectField.dataCode,
                            deCode: selectField.deCode,
                            value: currentValue,
                        }];
                    }
                } else {

                    if (selectField.type == 'date' && !currentValue) {
                        value = [{
                            dataCode: selectField.dataCode,
                            deCode: selectField.deCode,
                            value: new Date(),
                        }];
                    } else {
                        value = [{
                            dataCode: selectField.dataCode,
                            deCode: selectField.deCode,
                            value: currentValue,
                        }];
                    }


                }

                validation = true;
                if (value[0].value) {
                    validation = true;
                }
                else {
                    validation = false
                }
                if (validation) {
                    let params = {
                        formId: formId,
                        submit: false,
                        values: [...value]
                    }
                    setLoading(true);
                    api.saveForm(params).then(res => {
                        if (res.code == '0') {
                            let filterArr = res.data;
                            setSavedValue(filterArr)
                            setShowModal(false);
                            setSelectField(null);
                            setCurrentValue(null);
                        }
                        else {
                            Toast.fail(res.message, 1);
                        }
                        props.updateData();
                        setLoading(false);
                    })
                }
                else {
                    Toast.fail('请填写完整后再试！', 1);
                    isNullValidationIs = true
                }
            }
        } else {
            Toast.fail('请输入正确的格式！', 1);
            isNullValidationIs = true;
        }
    }

    /**
     * 递归查找下一题的配置信息
     * @param config   配置信息
     * @param dataCode 当前字段的数据编码
     * @param isNextNode 是否下一个目标节点
     * @returns nextFieldConfig 下一个字段胡配置信息
     */
    const deepNextField: any = (config: any, dataCode: string, isNextNode: boolean) => {
        // console.log('deepNextField-config:',config,',deepNextField-dataCode:',dataCode,',deepNextField-isNextNode:',isNextNode)
        // console.log('deepNextField-currentValue',currentValue)
        let result = {
            item: undefined,
            isNextNode: isNextNode
        };
        if (!config || config.length == 0) {
            return result;
        }
        for (let item of config) {
            // 显隐逻辑处理
            if (item.display) {
                let display = false;
                // 判断显隐逻辑是否满足 dataCode/target currentValue/rule
                // if (item.display.type === 'ValueCascade') {
                //     if (item.display.condition === 'eq') {
                //         // dataCode='' currentValue=''/[] rule='' target=''
                //         if (
                //             dataCode == item.display.target &&
                //             (currentValue == item.display.rule || currentValue.includes(item.display.rule))
                //         ) {
                //             display = true;
                //         }

                //     } else if (item.display.condition === 'oreq') {
                //         // dataCode='' currentValue=[] rule=[] target=''
                //         if (currentValue instanceof Array) {
                //             for (let i = 0; i < currentValue.length; i++) {
                //                 if (
                //                     dataCode == item.display.target &&
                //                     item.display.rule.includes(currentValue[i])
                //                 ) {
                //                     display = true;
                //                 }
                //             }

                //         } 
                //         // dataCode='' currentValue='' rule=[] target=''
                //         else {
                //             if (
                //                 dataCode == item.display.target &&
                //                 item.display.rule.includes(currentValue)
                //             ) {
                //                 display = true;
                //             }
                //         }
                //     } else if (item.display.condition === 'andEq') {
                //         // dataCode='' currentValue=[] rule=[] target=[]
                //         if (currentValue instanceof Array) {
                //             let target = item.display.target
                //             let rule = item.display.rule
                //             for (let i = 0; i < target.length-1; i++) {
                //                 if (
                //                     dataCode == target[i] && currentValue.includes(rule[i])
                //                 ) {
                //                     display = true;
                //                 }
                //             }
                //         } 
                //         // dataCode='' currentValue='' rule=[] target=[]
                //         else {
                //             let target = item.display.target
                //             let rule = item.display.rule
                //             for (let i = 0; i < target.length-1; i++) {
                //                 if (
                //                     dataCode == target[i] && currentValue == rule[i]
                //                 ) {
                //                     display = true;
                //                 }
                //             }
                //         }
                //     }
                // }
                //-----------------------------------------------------------------------------------------------------------
                if (item.display.type === 'ValueCascade') {
                    if (item.display.condition === 'eq') {
                        //当前选中表单已存的value
                        let currentItem = savedValue.find((i: any) => {
                            return i.dataCode == item.display.target
                        });
                        if (currentItem) {
                            if (!((currentItem.value && currentItem.value.indexOf(item.display.rule) !== -1) || (currentItem.value && currentItem.value === item.display.rule))) {
                                display = true;
                            }
                        }
                    }
                    else if (item.display.condition === 'oreq') {
                        let currentItem = savedValue.find((i: any) => {
                            return i.dataCode == item.display.target
                        });
                        if (currentItem && currentItem.value) {
                            if (currentItem.value instanceof Array) {
                                currentItem.value.length > 0 && currentItem.value.map((i: any) => {
                                    if (item.display.rule.includes(i)) {
                                        display = true;
                                    }
                                })
                            } else {
                                if (item.display.rule.includes(currentItem.value)) {
                                    display = true;
                                }
                            }
                        }
                    }
                    else if (item.display.condition === 'andEq') {
                        let list = savedValue.filter((i: any) => {
                            return item.display.target.includes(i.dataCode)
                        });

                        if (list && list.length > 0) {
                            for (let i = 0; i < list.length - 1; i++) {
                                if (list[i].value instanceof Array) {
                                    if (
                                        (list[i].dataCode == item.display.target[i] && list[i].value.includes(item.display.rule[i])) &&
                                        (list[i + 1].dataCode == item.display.target[i + 1] && list[i + 1].value.includes(item.display.rule[i + 1]))
                                    ) {
                                        display = true;
                                    }
                                } else {
                                    if (
                                        (list[i].dataCode == item.display.target[i] && list[i].value == item.display.rule[i]) &&
                                        (list[i + 1].dataCode == item.display.target[i + 1] && list[i + 1].value == item.display.rule[i + 1])
                                    ) {
                                        display = true;
                                    }
                                }
                            }
                        }
                    }
                }
                else if (currentValue instanceof Array) {
                    if (item.display.target instanceof Array) {
                        let i = item.display.target.indexOf(dataCode);
                        if (item.display.target[i] == dataCode) {
                            if (item.display.rule[i] instanceof Array) {
                                currentValue.map(rItem => {
                                    if (!item.display.rule[i].includes(rItem)) {
                                        display = true;
                                    }
                                })
                            } else {
                                if (!currentValue.includes(item.display.rule[i])) {
                                    display = true;
                                }
                            }
                        }
                    } else {
                        if (!currentValue.includes(item.display.rule) && item.display.target == dataCode) {
                            display = true;
                        }
                    }

                } else {
                    if (item.display.target instanceof Array) {
                        let i = item.display.target.indexOf(dataCode);
                        if (item.display.target[i] == dataCode && item.display.rule[i] != currentValue) {
                            display = true;
                        }
                    } else {
                        if (item.display.rule != currentValue && item.display.target == dataCode) {
                            display = true;
                        }
                    }
                }
                //-------------------------------------------------------------------------------------------------
                // if (currentValue instanceof Array) {

                //     if (item.display.condition === 'eq') {
                //         if (item.display.target == dataCode && currentValue.includes(item.display.rule)) {
                //             display = true;
                //         }
                //     }
                //     else if (item.display.condition === 'oreq') {
                //         for (let i = 0; i < currentValue.length - 1; i++) {
                //             if (item.display.target == dataCode && item.display.rule.includes(currentValue[i])) {
                //                 display = true;
                //             }
                //         }
                //     }
                //     else if (item.display.condition === 'andEq') {
                //         for (let i = 0; i < currentValue.length - 1; i++) {
                //             if (item.display.rule.includes(currentValue[i]) && item.display.target[i] == dataCode) {
                //                 display = true;
                //             }
                //         }
                //     }

                // } else {
                //     if (item.display.condition === 'eq') {
                //         if (item.display.target == dataCode && item.display.rule == currentValue) {
                //             display = true;
                //         }
                //     }
                //     else if (item.display.condition === 'oreq') {
                //         if (item.display.target == dataCode && item.display.rule.includes(currentValue)) {
                //             display = true;
                //         }
                //     }
                //     else if (item.display.condition === 'andEq') {
                //         let target = item.display.target
                //         let rule = item.display.rule
                //         for (let i = 0; i < rule.length - 1; i++) {
                //             if (currentValue == rule[i] && dataCode == target[i]) {
                //                 display = true;
                //             }
                //         }
                //     }
                // }

                if (display) {
                    continue;
                }
            }
            // 递归子节点
            if (item.children) {
                let nextConfig = deepNextField(item.children, dataCode, result.isNextNode);
                if (nextConfig.item) {
                    return nextConfig;
                } else {
                    result.isNextNode = nextConfig.isNextNode;
                    continue;
                }
            }
            // 如果当前节点是下一个节点，直接返回配置
            if (item.dataCode && result.isNextNode) {
                result.item = item;
                return result;
            }
            // 处理当前节点
            if (item.dataCode == dataCode) {
                result.isNextNode = true;
                continue;
            }

        }
        return result;
    }

    // 下一题
    const nextTopic = () => {
        // console.log('nextTopic-selectField:',selectField)

        /* setPhotos([]);
        setInfoPhotos([]); */

        // 必填项不跳转
        if (
            selectField.type != 'select' && selectField.type != 'input-select' && selectField.type != 'date' &&
            selectField.type != 'photo' && selectField.type != 'photo-oss' &&  selectField.type != "video" && selectField.type != "file" && validationIsNull(selectField) &&
            (!currentValue || currentValue == '' || currentValue == 'undefined')
        ) {
            // console.log('validationIsNull(selectField):',validationIsNull(selectField),',currentValue:',currentValue)
            setLoading(false)
            Toast.fail('请填写完整后再试！', 1)
            return
        }
        if (validationIsNull(selectField) && (selectField.type == 'photo' && (!photos || photos.length == 0))) {
            setPhotos([]);
            setInfoPhotos([]);
            setLoading(false)
            Toast.fail('请填写完整后再试！', 1)
            return
        }
        if (validationIsNull(selectField) && (selectField.type == 'photo-oss' && (!photos || photos.length == 0))) {
            setPhotos([]);
            setInfoPhotos([]);
            setLoading(false)
            Toast.fail('请填写完整后再试！', 1)
            return
        }

        if (validationIsNull(selectField) && (selectField.type == 'video' && (!videos || videos.length == 0))) {
            setVideos([])
            setLoading(false)
            Toast.fail('请填写完整后再试！', 1)
            return
        }

        if (validationIsNull(selectField) && (selectField.type == 'file' && (!filesData || filesData.length == 0))) {
            setFilesData([])
            setLoading(false)
            Toast.fail('请填写完整后再试！', 1)
            return
        }

        if (selectField.type != 'input-select' && selectField.type != "select" && selectField.type != "photo" && selectField.type != "video" && selectField.type != "file") {
            /* if(validationIsNull(selectField)) {
                if(selectNoteType == 'DataActionUpdate') {
                    onUpdate();
                }else {
                    onSave()
                }
            } */
            if (selectNoteType == 'DataActionUpdate') {
                onUpdate()
            } else {
                onSave()
            }
            // onSave()
        }
        // console.log('isNullValidationIs:',isNullValidationIs)
        if (isNullValidationIs) {
            return;
        }

        setCurrentValue(null)

        // console.log('执行getNextTopic')
        let nextFieldConfig = deepNextField(fieldList, selectField.dataCode, false);
        // console.log('nextFieldConfig:',nextFieldConfig)
        if (nextFieldConfig.item) {
            let currentItem = savedValue.find((i: any) => {
                return i.dataCode == nextFieldConfig.item.dataCode
            });

            if (currentItem) {
                if (nextFieldConfig.item.type === 'photo' || nextFieldConfig.item.type === 'photo-oss' || nextFieldConfig.item.type === 'video' || nextFieldConfig.item.type === 'file') {
                    let filterArr: any = [];
                    let _url: any = [];
                    for (let Item of currentItem.value) {
                        filterArr.push(
                            {
                                url: Item
                            }
                        )
                        _url.push(Item);
                    }
                    let suffixPhotos = changedPhoto(filterArr);

                    if (nextFieldConfig.item.type === 'photo'||nextFieldConfig.item.type === 'photo-oss') {
                        setPhotos(suffixPhotos);
                        setInfoPhotos(getInfoTipPhoto(suffixPhotos));
                    }
                    else if (nextFieldConfig.item.type === 'video') {
                        setVideos(suffixPhotos)
                    }
                    else if (nextFieldConfig.item.type === 'file') {
                        setFilesData(suffixPhotos)
                    }
                }

                setCurrentValue(currentItem.value)

            } else {
                /* if (selectField.type == "date") {
                    setCurrentValue(new Date())
                } */
                // 如果下一题是date类型，将当前时间设为默认填写值
                if (nextFieldConfig.item.type == 'date') {
                    setCurrentValue(new Date())
                }
                else if (nextFieldConfig.item.type === 'checkbox') {
                    setCurrentValue(Array(Object.keys(nextFieldConfig.item.optional).length).fill(''));
                }
                else if (nextFieldConfig.item.type === 'photo'||nextFieldConfig.item.type === 'photo-oss') {
                    setPhotos([]);
                    setInfoPhotos([]);
                }
                else if (nextFieldConfig.item.type === 'video') {
                    setVideos([])
                }
                else if (nextFieldConfig.item.type === 'file') {
                    setFilesData([])
                }
            }

            setSelectField(nextFieldConfig.item)
            fillFormBtn(nextFieldConfig.item)
        }
        else {
            if (nextFieldConfig.isNextNode) {
                setShowModal(false);
            }
        }
    }

    //修改数据
    const onUpdate = () => {
        if (!inputError) {

            if (selectField.type === 'input-select') {
                if (selectField.other && selectValue.indexOf(selectField.other.key) !== -1) {
                    if (inputValue && otherValue) {
                        let value;
                        //自动补零
                        if (inputValue.indexOf(".") !== -1) {
                            if (inputValue.indexOf(".") === inputValue.length - 1) {
                                setInputValue(inputValue + '0');
                                value = [inputValue + '0', otherValue];
                            } else {
                                value = [inputValue, otherValue];
                            }
                        }
                        else {
                            value = [inputValue, otherValue];
                        }
                        let params = {
                            formId: formId,
                            deCode: selectField.deCode,
                            dataCode: selectField.dataCode,
                            value: value
                        }
                        setLoading(true);
                        api.updateData(params).then(res => {
                            if (res.code == '0') {
                                Toast.success('修改成功！', 1)
                                //更新当前表单数据
                                getDataById();
                                // onCloseModal()
                            }
                            else {
                                Toast.fail(res.message, 1)
                            }
                            props.updateData();
                            setLoading(false);
                        })
                    }
                    else {
                        Toast.fail('请填写完整后再试！', 1);
                        isNullValidationIs = true
                    }
                } else {
                    if (inputValue && selectValue) {
                        let value;
                        //自动补零
                        if (inputValue.indexOf(".") !== -1) {
                            if (inputValue.indexOf(".") === inputValue.length - 1) {
                                setInputValue(inputValue + '0');
                                value = [inputValue + '0', selectValue];
                            } else {
                                value = [inputValue, selectValue];
                            }
                        }
                        else {
                            value = [inputValue, selectValue];
                        }
                        let params = {
                            formId: formId,
                            deCode: selectField.deCode,
                            dataCode: selectField.dataCode,
                            value: value
                        }
                        setLoading(true);
                        api.updateData(params).then(res => {
                            if (res.code == '0') {
                                Toast.success('修改成功！', 1)
                                //更新当前表单数据
                                getDataById();
                                // onCloseModal()
                            }
                            else {
                                Toast.fail(res.message, 1)
                            }
                            props.updateData();
                            setLoading(false);
                        })
                    }
                    else {
                        Toast.fail('请填写完整后再试！', 1);
                        isNullValidationIs = true
                    }
                }
            }
            else if (selectField.type === 'checkbox') {

                let value;
                let validation = true;

                //若包含other字段
                if (selectField.other) {
                    let filterValue;
                    if (currentValue && currentValue.indexOf(selectField.other.key) !== -1) {
                        if (otherValue) {
                            filterValue = currentValue.concat(otherValue.trim());
                        }
                        else {
                            filterValue = currentValue;
                        }
                    }
                    else {
                        filterValue = currentValue;
                    }
                    value = filterValue;
                }
                else {
                    value = currentValue;
                }
                let judgeNullArr = JSON.parse(JSON.stringify(value));
                for (let i = 0; i < judgeNullArr.length; i++) {
                    if (judgeNullArr[i] == '' || judgeNullArr[i] == null || judgeNullArr[i] == undefined) {
                        judgeNullArr.splice(i, 1)
                        i = i - 1;
                    }
                }
                if (judgeNullArr && judgeNullArr.length > 0) {
                    if (selectField.other) {
                        if (currentValue && currentValue.indexOf(selectField.other.key) !== -1) {
                            if (otherValue && otherValue.trim()) {
                                validation = true;
                            }
                            else {
                                validation = false;
                            }
                        }
                    }
                    else {
                        validation = true;
                    }
                }
                else {
                    validation = false;
                }
                if (validation) {
                    setLoading(true);
                    let params = {
                        formId: formId,
                        deCode: selectField.deCode,
                        dataCode: selectField.dataCode,
                        value: value
                    }
                    api.updateData(params).then(res => {
                        if (res.code == '0') {
                            Toast.success('修改成功！', 1)
                            //更新当前表单数据
                            getDataById();
                            // onCloseModal()
                        }
                        else {
                            Toast.fail(res.message, 1)
                        }
                        props.updateData();
                        setLoading(false);
                    })
                }
                else {
                    Toast.fail('请填写完整后再试！', 1);
                    isNullValidationIs = true
                }
            }
            else {
                let value;
                let validation = true;
                if (selectField.type === 'select') {
                    value = currentValue;
                    //若包含other字段
                    if (selectField.other) {
                        if (currentValue && currentValue.indexOf(selectField.other.key) !== -1) {
                            if (selectField.other.type === 'input') {
                                if (otherValue && otherValue.trim()) {
                                    value = otherValue.trim();
                                    validation = true;
                                }
                                else {
                                    validation = false;
                                }
                            }
                            else if (selectField.other.type === 'date') {
                                if (otherValue) {
                                    value = otherValue;
                                    validation = true;
                                }
                                else {
                                    validation = true;
                                    value = new Date();
                                }
                            }
                        }
                        else {
                            value = currentValue;
                            validation = true;
                        }
                    }
                    else {
                        value = currentValue;
                    }
                }
                else if (selectField.type === 'decimal') {
                    //自动补零
                    if (currentValue.indexOf(".") !== -1) {
                        if (currentValue.indexOf(".") === currentValue.length - 1) {
                            setCurrentValue(currentValue + '0');
                            value = currentValue + '0'
                        } else {
                            value = currentValue
                        }
                    }
                    else {
                        value = currentValue
                    }
                }
                else {
                    value = currentValue;
                }


                if (selectField.type == 'number' || selectField.type == 'decimal') {
                    let judge = verify.checkValueByRange(value, selectField)

                    if (!judge) {
                        return false
                    }
                }


                if (value && validation) {
                    let params = {
                        formId: formId,
                        deCode: selectField.deCode,
                        dataCode: selectField.dataCode,
                        value: value
                    }
                    setLoading(true);
                    api.updateData(params).then(res => {
                        if (res.code == '0') {
                            Toast.success('修改成功！', 1)
                            //更新当前表单数据
                            getDataById();
                            // onCloseModal()
                        }
                        else {
                            Toast.fail(res.message, 1)
                        }
                        props.updateData();
                        setLoading(false);
                    })
                }
                else {
                    Toast.fail('请填写完整后再试！', 1);
                    isNullValidationIs = true
                }
            }
        }
        else {
            Toast.fail('请输入正确的格式！', 1);
        }
    }

    //当选择了注释
    const onAnnotationChange = (value: any) => {
        return () => {
            setAnnotationValue(value)
        }
    }

    //注释表单
    const onAnnotation = () => {
        if (annotationValue) {
            let params = {
                formId: formId,
                deCode: selectField.deCode,
                dataCode: selectField.dataCode,
                annotation: annotationValue,
            }
            setLoading(true);
            api.annotationData(params).then(res => {
                if (res.code == '0') {
                    Toast.success('注释成功！', 1);
                    //更新当前表单数据
                    getDataById();
                    // setShowModal(false);
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1);
                    }
                    else {
                        Toast.fail('注释失败！', 1);
                    }
                }
                setLoading(false);
            })
        }
        else {
            Toast.fail('请选择后再试！', 1);
        }
    }

    //当备注表单
    const onRemark = () => {
        if (remarkValue && remarkValue.trim()) {
            let params = {
                formId: formId,
                deCode: selectField.deCode,
                dataCode: selectField.dataCode,
                remark: remarkValue.trim(),
            }
            setLoading(true);
            api.remarkData(params).then(res => {
                if (res.code == '0') {
                    Toast.success('备注成功！', 1);
                    //更新当前表单数据
                    getDataById();
                    // setShowModal(false);
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1);
                    }
                    else {
                        Toast.fail('备注失败！', 1);
                    }
                }
                setLoading(false);
            })
        }
        else {
            Toast.fail('请输入备注内容后再提交！', 1);
        }
    }

    //当质疑操作
    const onQuestion = () => {
        if (selectQuestionType && questionInf) {
            let params = {
                content: questionInf,
                dataCode: selectField.dataCode,
                deCode: selectField.deCode,
                formActions: formActions,
                formId: formId,
                // sendTo: '',
                type: selectQuestionType[0]
            }
            setLoading(true);
            api.addQuestion(params).then(res => {
                if (res.code == '0') {
                    Toast.success('创建质疑成功！', 1)
                    setSelectFieldQuestion(res.data);
                    //清空检查的类型
                    setSelectQuestionType(null);
                    //清空检查说明
                    setQuestionInf(null);
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1)
                    }
                    else {
                        Toast.fail('创建质疑失败！', 1)
                    }
                }
                setLoading(false);
            })
        }
        else {
            Toast.fail('请填写完整后再提交质疑', 1)
        }
    }

    //痕迹稽查
    const onTrance = () => {

    }

    //回复质疑
    const onAnswerQuestion = () => {
        let params = {
            content: supplementInf,
            dataCode: selectField.dataCode,
            deCode: selectField.deCode,
            formId: formId,
            questionId: selectQuestionItemId,
            type: currentQuestionType,
            value: questionModifyValue
        }
        setLoading(true);
        api.answerQuestion(params).then(res => {
            if (res.code == '0') {
                setSelectFieldQuestion(res.data);
                Toast.success('保存成功！', 1);
                //更新表单数据
                getDataById();
                setSupplementInf('');
                setQuestionModifyValue('');
                setSelectQuestionItemId(null);
                // setShowModal(false);
            }
            else {
                if (res.message) {
                    Toast.fail(res.message, 1)
                }
                else {
                    Toast.fail('保存失败', 1)
                }
            }
            setLoading(false);
        })
    }

    //关闭质疑
    const closeQuestion = (id: any) => {
        return () => {
            let params = {
                dataCode: selectField.dataCode,
                deCode: selectField.deCode,
                formId: formId,
                questionId: id,
            }
            setLoading(true);
            api.closeQuestion(params).then(res => {
                if (res.code == '0') {
                    setSelectFieldQuestion(res.data);
                    Toast.success('关闭成功！', 1);
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1)
                    }
                    else {
                        Toast.fail('关闭失败！', 1)
                    }
                }
                setLoading(false);
            })
        }
    }

    //重新打开质疑
    const reopenQuestion = (id: any) => {
        return () => {
            let params = {
                dataCode: selectField.dataCode,
                deCode: selectField.deCode,
                formId: formId,
                questionId: id,
            }
            setLoading(true);
            api.reopenQuestion(params).then(res => {
                if (res.code == '0') {
                    setSelectFieldQuestion(res.data);
                    Toast.success('重新打开成功！', 1);
                }
                else {
                    if (res.message) {
                        Toast.fail(res.message, 1)
                    }
                    else {
                        Toast.fail('重新打开失败！', 1)
                    }
                }
                setLoading(false);
            })
        }
    }

    //当图片选择改变时
    const onPhotoChange = (files: any) => {
        setPhotos(files)
        setInfoPhotos(getInfoTipPhoto(files));
    }

    /**
     * 当视频选择改变时
     * @param files 
     */
    const onVideoChange = (files: any) => {
        setVideos(files)
    }

    /**
     * 当文件选择改变时
     * @param files 
     */
    const onFileChange = (files: any) => {
        setFilesData(files)
    }

    const afterUploadSaveData = () => {
        // @ts-ignore
        if (formUpdateParams && formUpdateParams.selectNoteType === 'DataActionInput') {
            saveFormRequest();
            // @ts-ignore
        } else if (formUpdateParams && formUpdateParams.selectNoteType === 'DataActionUpdate') {
            updateDataRequest();
        }
    }

    // 保存1
    const saveFormRequest = () => {
        const params = {
            formId: formUpdateParams.formId,
            submit: formUpdateParams.submit,
            values: formUpdateParams.values
        }
        // @ts-ignore
        api.saveForm(params).then(res => {
            if (res.code == '0') {
                let filterArr = res.data;
                setSavedValue(filterArr);
            }
            else {
                Toast.fail(res.message, 1);
            }
            props.updateData();
        })
    }

    // 保存2
    const updateDataRequest = () => {
        const params = {
            formId: formUpdateParams.formId,
            deCode: formUpdateParams.deCode,
            dataCode: formUpdateParams.dataCode,
            value: formUpdateParams.value
        }
        api.updateData(params).then(res => {
            if (res.code == '0') {
                //更新当前表单数据
                getDataById();
            }
            else {
                Toast.fail(res.message, 1)
            }
        })
    }

    // 实时上传方法
    const onUpload = (item: any): Promise<object | undefined> => {
        return new Promise((resolve, reject) => {
            let uploadFormData = new FormData();
            uploadFormData.append("file", item.file);
            // 识别图片成功

            // axios.post("/data/data/image", uploadFormData, {{ // 之前的图片上传
            axios.post("/file/image/upload", uploadFormData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "x-formId-code": formId,
                    // @ts-ignore 首页进来时点击条目的projectCode
                    "x-projectCode-code": itemData.projectCode,
                    // @ts-ignore 首页进来时点击条目的subjectCode
                    "x-subjectCode-code": encodeURIComponent(itemData.subjectCode)
                }
            }).then(res => {
                if (res.data.code == '0') {
                    // let url = res.data.data; // 之前的图片上传数据结构
                    let url = res.data.data.url;
                    let isDesensitization = res.data.data.isDesensitization;
                    resolve({ url: url });
                    photos.push(
                        {
                            url: url
                        }
                    )
                    //若当前为录入权限
                    setLoading(true);
                    // console.log('selectNoteType:',selectNoteType)
                    if (selectNoteType === 'DataActionInput') {
                        //暂存数据
                        if (photos) {
                            let filterPhotos = [];
                            for (let item of photos) {
                                // 上传时还原来的图片地址
                                let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                                filterPhotos.push(_originUrl)
                            }
                            let value = [{
                                dataCode: selectField.dataCode,
                                deCode: selectField.deCode,
                                value: filterPhotos,
                            }];
                            let params = {
                                formId: formId,
                                submit: false,
                                values: [...value]
                            }
                            setFormUpdateParams({ ...params, selectNoteType, isDesensitization });
                            // 需要脱敏，脱敏完成后再保存，自动跳转
                            if (isDesensitization == 1 || isOcr) {
                                setOcrRecongize(true)
                                setLoading(false);
                                setCurrentPhotoIndex(filterPhotos.length - 1);
                                setPhotoVisible(true);
                                setShowModal(false);
                            } else {

                                api.saveForm(params).then(res => {
                                    if (res.code == '0') {
                                        let filterArr = res.data;
                                        setSavedValue(filterArr);
                                        props.updateData();
                                        Toast.success('保存成功！', 1);
                                    }
                                    else {
                                        Toast.fail(res.message, 1);
                                    }
                                    setLoading(false);
                                })
                            }
                        }
                    }
                    else if (selectNoteType === 'DataActionUpdate') {
                        let filterPhotos = [];
                        for (let item of photos) {
                            // 上传时还原来的图片地址
                            let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                            filterPhotos.push(_originUrl)
                        }
                        let params = {
                            formId: formId,
                            deCode: selectField.deCode,
                            dataCode: selectField.dataCode,
                            value: filterPhotos
                        }
                        setFormUpdateParams({ ...params, selectNoteType, isDesensitization });
                        // 需要脱敏，脱敏完成后再保存
                        if (isDesensitization == 1 || isOcr) {
                            setOcrRecongize(true)
                            setLoading(false);
                            setCurrentPhotoIndex(filterPhotos.length - 1);
                            setPhotoVisible(true);
                            setShowModal(false);
                        } else {
                            api.updateData(params).then(res => {
                                if (res.code == '0') {
                                    Toast.success('保存成功', 1)
                                    //更新当前表单数据
                                    getDataById();
                                }
                                else {
                                    Toast.fail(res.message, 1)
                                }
                                props.updateData();
                            })
                        }
                    }
                    else {
                        Toast.fail('您尚无此权限！', 1);
                        setLoading(false);
                    }
                }
                else {
                    reject('图片上传失败！')
                    Toast.fail('图片上传失败！', 1);
                }
            })
        });
    };

    // 查看大图方法
    const onGetPreviewUrl = (index: number): Promise<string> => {
        return new Promise((resolve, reject) => {
            // 点击查看肯定是否OCR识别过
            setOcrRecongize(false)
            // 设置当前点击的图片索引
            setCurrentPhotoIndex(index)
            // 设置显示预览
            setPhotoVisible(true);
            // 关闭弹框
            setShowModal(false)
        });
    };

    // 只读查看大图方法
    const onReadOnlyPreview = (index: number, item: any): Promise<string> => {
        return new Promise((resolve, reject) => {
            setCurrentPhotoIndex(index)
            // 设置显示预览
            setPhotos(item);
            setPhotoVisible(true);
        });
    };

    /**
     * 查看视频
     * @param index 
     * @returns 
     */
    const onGetVideoPreviewUrl = (index: number): Promise<string> => {
        return new Promise((resolve, reject) => {
            // 点击查看肯定是否OCR识别过
            // setOcrRecongize(false)
            // 设置当前点击的图片索引
            setCurrentPhotoIndex(index)
            // 设置显示预览
            // setPhotoVisible(true);
            // 关闭弹框
            setShowModal(false)
        });
    }

    /**
     * 查看文件
     * @param index 
     * @returns 
     */
    const onGetFilePreviewUrl = (index: number): Promise<string> => {
        return new Promise((resolve, reject) => {
            // 点击查看肯定是否OCR识别过
            // setOcrRecongize(false)
            // 设置当前点击的图片索引
            setCurrentPhotoIndex(index)
            // 设置显示预览
            // setPhotoVisible(true);
            // 关闭弹框
            setShowModal(false)
        });
    }

    /**
     * 提取上传类型
     * @param {*} json 
     * @returns 
     */
    const filterPathPre = (json: any, type?: any) => {
        let newJson = json;
        let data: any = [];
        data = newJson.pathPre.split(',')
        data.map((i: any) => {
            if (i.includes(type)) {
                newJson.pathPre = i
            }
        })

        return newJson
    }

    /**
     * 获取OSS访问令牌
     */
    const getOssData = () => {
        api.GetCaseSts().then((res: any) => {
            if (res.code == 0) {
                if (!res.data) {
                    return
                }
                setOssData(res.data)
            }
        })
    };

    /**
     * 相同大小视频处理
     */
    const dealSameVideo = () => {
        api.getDealSameVideo({
            // @ts-ignore
            projectCode: itemData.projectCode || '',
            // @ts-ignore
            subjectCode: itemData.subjectCode || '',
            videoName: vedioFile.name || '',
            videoSize: vedioFile.size || '',
        }).then(res => {
            if (res.code == '0') {
                console.log('相同大小视频处理')
            }
        })
    }

    /**
     * 上传视频
     * @param item 
     * @returns 
     */
    const onVideoUpload = (item: any): Promise<object | undefined> => {
        let client = new OSS({ ...filterPathPre(ossData, 'video') });
        return new Promise((resolve, reject) => {
            const file = item.file;
            let tenantCode = localStorage.getItem('tenantCode')
            let accountInf = localStorage.getItem('accountInf')
            let accounData = accountInf ? JSON.parse(accountInf) : {}
            //处理FileReader
            const reader = new FileReader();
            reader.readAsDataURL(file);
            let start = Date.now();
            reader.onloadend = (e) => {
                const suffix = file.name.slice(file.name.lastIndexOf('.'));
                let time = new Date().getTime();
                const path = `${ossData.pathPre}${tenantCode}/${accounData.account}/${time}${suffix}`;
                // oss上传
                // client.put(
                //     path,
                //     file,
                // ).then((res: any) => {
                client.multipartUpload(
                    path,
                    file,
                    {
                        // 获取分片上传进度、断点和返回值。
                        progress: (p, cpt, res) => {
                            let timer;
                            if (p > 0) {
                                timer = Math.floor((Date.now() - start) * (1 - p) / p / 1000);
                                timer = timer > 60 ? Math.floor(timer / 60) + "分" + timer % 60 + "秒" : timer + "秒";
                            } else {
                                timer = '计算中';
                            }
                            setVedioProgress({
                                pre: Math.floor(p * 1000) / 10 + '%',
                                rt: Math.floor(res.rt / 100) + 'kb/s',
                                timer: timer
                            })
                        },
                        // 设置并发上传的分片数量。
                        parallel: 4,
                        // 设置分片大小。默认值为1 MB，最小值为100 KB。
                        partSize: 1024 * 1024 * 10,
                        mime: "text/plain",
                        timeout: 600 * 1000
                    }
                ).then((res: any) => {
                    setVedioProgress(null)
                    if (res.res.status !== 200) {
                        Toast.info(`视频上传失败，请重试！`);
                        return;
                    }
                    let url = res.res.requestUrls[0];
                    url = url.substring(0, url.indexOf("?"));
                    resolve({ url: url });
                    videos.push(
                        {
                            url: url
                        }
                    )
                    //若当前为录入权限
                    setLoading(true);
                    if (selectNoteType === 'DataActionInput') {
                        //暂存数据
                        if (videos) {
                            let filterVideos = [];
                            for (let item of videos) {
                                // 上传时还原来的图片地址
                                let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                                filterVideos.push(_originUrl)
                            }
                            let value = [{
                                dataCode: selectField.dataCode,
                                deCode: selectField.deCode,
                                value: filterVideos,
                            }];
                            let params = {
                                formId: formId,
                                submit: false,
                                values: [...value]
                            }
                            setFormUpdateParams({ ...params, selectNoteType });
                            api.saveForm(params).then(res => {
                                if (res.code == '0') {
                                    let filterArr = res.data;
                                    setSavedValue(filterArr);
                                    // 相同大小视频处理 
                                    setVideoFile(file)
                                }
                                else {
                                    Toast.fail(res.message, 1);
                                }
                                setLoading(false);
                            })
                        }
                    }
                    else if (selectNoteType === 'DataActionUpdate') {
                        let filterVideos = [];
                        for (let item of videos) {
                            // 上传时还原来的图片地址
                            let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                            filterVideos.push(_originUrl)
                        }
                        let params = {
                            formId: formId,
                            deCode: selectField.deCode,
                            dataCode: selectField.dataCode,
                            value: filterVideos
                        }
                        setFormUpdateParams({ ...params, selectNoteType });
                        api.updateData(params).then(res => {
                            if (res.code == '0') {
                                Toast.success('保存成功', 1)
                                // 相同大小视频处理 
                                setVideoFile(file)
                                //更新当前表单数据
                                getDataById();
                            }
                            else {
                                Toast.fail(res.message, 1)
                            }
                            setLoading(false);
                        })
                    }
                    else {
                        Toast.fail('您尚无此权限！', 1);
                        setLoading(false);
                    }
                })
            }
        });
    };

    /**
     * 上传文件
     * @param item 
     * @returns 
     */
    const onFileUpload = (item: any): Promise<object | undefined> => {
        let client = new OSS({ ...filterPathPre(ossData, 'file') });
        return new Promise((resolve, reject) => {
            const file = item.file;
            let tenantCode = localStorage.getItem('tenantCode')
            let accountInf = localStorage.getItem('accountInf')
            let accounData = accountInf ? JSON.parse(accountInf) : {}
            //处理FileReader
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (e) => {
                const suffix = file.name.slice(file.name.lastIndexOf('.'));
                let time = new Date().getTime();
                const path = `${ossData.pathPre}${tenantCode}/${accounData.account}/${time}${suffix}`;
                // oss上传
                client.put(
                    path,
                    file,
                ).then((res: any) => {
                    let url = res.url;
                    resolve({ url: url });
                    filesData.push(
                        {
                            url: url
                        }
                    )
                    //若当前为录入权限
                    setLoading(true);
                    if (selectNoteType === 'DataActionInput') {
                        //暂存数据
                        if (filesData) {
                            let filterFile = [];
                            for (let item of filesData) {
                                // 上传时还原来的图片地址
                                let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                                filterFile.push(_originUrl)
                            }
                            let value = [{
                                dataCode: selectField.dataCode,
                                deCode: selectField.deCode,
                                value: filterFile,
                            }];
                            let params = {
                                formId: formId,
                                submit: false,
                                values: [...value]
                            }
                            setFormUpdateParams({ ...params, selectNoteType });
                            api.saveForm(params).then(res => {
                                if (res.code == '0') {
                                    let filterArr = res.data;
                                    setSavedValue(filterArr);
                                    Toast.success('保存成功！', 1);
                                }
                                else {
                                    Toast.fail(res.message, 1);
                                }
                                setLoading(false);
                            })
                        }
                    }
                    else if (selectNoteType === 'DataActionUpdate') {
                        let filterFile = [];
                        for (let item of filesData) {
                            // 上传时还原来的图片地址
                            let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                            filterFile.push(_originUrl)
                        }
                        let params = {
                            formId: formId,
                            deCode: selectField.deCode,
                            dataCode: selectField.dataCode,
                            value: filterFile
                        }
                        setFormUpdateParams({ ...params, selectNoteType });
                        api.updateData(params).then(res => {
                            if (res.code == '0') {
                                Toast.success('保存成功', 1)
                                //更新当前表单数据
                                getDataById();
                            }
                            else {
                                Toast.fail(res.message, 1)
                            }
                            setLoading(false);
                        })
                    }
                    else {
                        Toast.fail('您尚无此权限！', 1);
                        setLoading(false);
                    }
                })
            }
        });
    };

    //当点击了添加list按钮
    const onClickAddList = (item: any) => {
        return () => {
            setFieldList(tool.addList(JSON.parse(JSON.stringify(fieldList)), item.id));
        }
    }

    //当图片删除
    const onPhotoDelete = (fileList: any) => {
        //若当前为录入权限
        setLoading(true);
        if (selectNoteType === 'DataActionInput') {
            //暂存数据
            if (fileList) {
                let filterPhotos = [];
                for (let item of fileList) {
                    // 上传时还原来的图片地址
                    let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                    filterPhotos.push(_originUrl)
                }
                let value = [{
                    dataCode: selectField.dataCode,
                    deCode: selectField.deCode,
                    value: filterPhotos,
                }];
                let params = {
                    formId: formId,
                    submit: false,
                    values: [...value]
                }
                api.saveForm(params).then(res => {
                    if (res.code == '0') {
                        let filterArr = res.data;
                        setSavedValue(filterArr);
                        Toast.success('删除成功！', 1);
                    }
                    else {
                        Toast.fail(res.message, 1);
                    }
                    setLoading(false);
                    props.updateData()
                })
            }
        }
        else if (selectNoteType === 'DataActionUpdate') {
            let filterPhotos = [];
            for (let item of fileList) {
                // 上传时还原来的图片地址
                let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                filterPhotos.push(_originUrl)
            }

            let userInfo = sessionStorage.getItem('token');
            let userData = userInfo ? JSON.parse(userInfo) : {}

            let params = {
                formId: formId,
                deCode: selectField.deCode,
                dataCode: selectField.dataCode,
                value: filterPhotos,
                dataTenantCode: userData.tenantCode || ''
            }
            api.DeleteImageData(params).then(res => {
                if (res.code == '0') {
                    Toast.success('删除成功！', 1)
                    //更新当前表单数据
                    getDataById();
                }
                else {
                    Toast.fail(res.message, 1)
                }
                setLoading(false);
            })
        }
        else {
            Toast.fail('您尚无此权限！', 1);
            setLoading(false);
        }
    }

    /**
     * 删除视频
     * @param fileList 
     */
    const onVideoDelete = (fileList: any) => {
        //若当前为录入权限
        setLoading(true);
        if (selectNoteType === 'DataActionInput') {
            //暂存数据
            if (fileList) {
                let filterVideos = [];
                for (let item of fileList) {
                    // 上传时还原来的图片地址
                    let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                    filterVideos.push(_originUrl)
                }
                let value = [{
                    dataCode: selectField.dataCode,
                    deCode: selectField.deCode,
                    value: filterVideos,
                }];
                let params = {
                    formId: formId,
                    submit: false,
                    values: [...value]
                }
                api.saveForm(params).then(res => {
                    if (res.code == '0') {
                        let filterArr = res.data;
                        setSavedValue(filterArr);
                        Toast.success('删除成功！', 1);
                    }
                    else {
                        Toast.fail(res.message, 1);
                    }
                    setLoading(false);
                })
            }
        }
        else if (selectNoteType === 'DataActionUpdate') {
            let filterVideos = [];
            for (let item of fileList) {
                // 上传时还原来的图片地址
                let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                filterVideos.push(_originUrl)
            }

            let userInfo = sessionStorage.getItem('token');
            let userData = userInfo ? JSON.parse(userInfo) : {}

            let params = {
                formId: formId,
                deCode: selectField.deCode,
                dataCode: selectField.dataCode,
                value: filterVideos,
                dataTenantCode: userData.tenantCode || ''
            }
            api.DeleteImageData(params).then(res => {
                if (res.code == '0') {
                    Toast.success('删除成功！', 1)
                    //更新当前表单数据
                    getDataById();
                }
                else {
                    Toast.fail(res.message, 1)
                }
                setLoading(false);
            })
        }
        else {
            Toast.fail('您尚无此权限！', 1);
            setLoading(false);
        }
    }

    /**
     * 删除文件
     * @param fileList 
     */
    const onFileDelete = (fileList: any) => {
        //若当前为录入权限
        setLoading(true);
        if (selectNoteType === 'DataActionInput') {
            //暂存数据
            if (fileList) {
                let filterVideos = [];
                for (let item of fileList) {
                    // 上传时还原来的图片地址
                    let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                    filterVideos.push(_originUrl)
                }
                let value = [{
                    dataCode: selectField.dataCode,
                    deCode: selectField.deCode,
                    value: filterVideos,
                }];
                let params = {
                    formId: formId,
                    submit: false,
                    values: [...value]
                }
                api.saveForm(params).then(res => {
                    if (res.code == '0') {
                        let filterArr = res.data;
                        setSavedValue(filterArr);
                        Toast.success('删除成功！', 1);
                    }
                    else {
                        Toast.fail(res.message, 1);
                    }
                    setLoading(false);
                })
            }
        }
        else if (selectNoteType === 'DataActionUpdate') {
            let filterVideos = [];
            for (let item of fileList) {
                // 上传时还原来的图片地址
                let _originUrl = (item.url.indexOf('?') >= 0) ? item.url.split('?')[0] : item.url
                filterVideos.push(_originUrl)
            }

            let userInfo = sessionStorage.getItem('token');
            let userData = userInfo ? JSON.parse(userInfo) : {}

            let params = {
                formId: formId,
                deCode: selectField.deCode,
                dataCode: selectField.dataCode,
                value: filterVideos,
                dataTenantCode: userData.tenantCode || ''
            }
            api.DeleteImageData(params).then(res => {
                if (res.code == '0') {
                    Toast.success('删除成功！', 1)
                    //更新当前表单数据
                    getDataById();
                }
                else {
                    Toast.fail(res.message, 1)
                }
                setLoading(false);
            })
        }
        else {
            Toast.fail('您尚无此权限！', 1);
            setLoading(false);
        }
    }

    //判断是否加载更多
    const isAddMore = (item: any) => {

        //角色code为ReadOnly 表单只读
        let token: any = sessionStorage.getItem('token');
        let projectRoleCode = sessionStorage.getItem('projectRoleCode');
        token = JSON.parse(token);
        if (token.roleCode == 'EDC_READ' || projectRoleCode == "ReadOnly") {
            return ""
        }

        if (formActions.indexOf('FormActionSubmit') !== -1 || editModel == '1') {
            return (
                <div className="addNextList" onClick={onClickAddList(item)}>
                    点击加载更多
                    <img src={more} alt="more" />
                </div>
            )
        }
    }


    //判断是否显示删除
    const isShowDelete = (i: any, item: any) => {
        //角色code为ReadOnly 表单只读
        let token: any = sessionStorage.getItem('token');
        let projectRoleCode = sessionStorage.getItem('projectRoleCode');
        token = JSON.parse(token);
        if (token.roleCode == 'EDC_READ' || projectRoleCode == "ReadOnly") {
            return ""
        }

        if (formActions.indexOf('FormActionSubmit') !== -1 || editModel == '1') {
            return (
                <div
                    onClick={() => deleteListItem(i, item)}
                    style={{ fontSize: 12, color: '#ff4d4f', marginLeft: 15, display: i == 0 ? 'none' : (i + 1) !== item.children.length ? 'none' : '' }}
                >[删除本节点]</div>
            )
        }
    }


    const findAllValues = (data: any) => {
        let returnData: any = []
        if (data.children) {
            data.children.forEach((v: any) => {
                if (v.type == "group") {
                    let _data = findAllValues(v)
                    returnData = [...returnData, ..._data]
                } else {
                    returnData.push(v)
                }
            });
        }
        return returnData
    }


    //list题型删除某一项
    const deleteListItem = (index: any, item: any) => {
        let { _data, _list } = tool.deleteListItem(JSON.parse(JSON.stringify(fieldList)), item.id, index)
       
        _list = findAllValues(_list)
        if (_list) {
           

            let deleteFormData: any = _list.map((v: any) => ({
                dataCode: v.dataCode,
                deCode: v.deCode,
            }))

            let params = {
                formId: formId,
                values: deleteFormData
            }
            // 判断是否能够删除
            api.isDisableDelete(params).then((res:any)=>{
                if(res.code == 0) {
                    if(res.data){
                        setFieldList(_data);
                        
                        let _savedValues = savedValue
                        _list.forEach((_item: any) => {
                            let Index = _savedValues.findIndex((v: any) => v.dataCode == _item.dataCode)
                            if (Index > -1) {
                                _savedValues.splice(Index, 1)
                            }
                        })
                        api.deleteData(params).then((res: any) => {
                            if (res.code == 0) {
                                // props.updateData();
                                setSavedValue(_savedValues)
                            }
                        })                    
                    }else{
                       return Toast.fail("该纪录已审核通过，不可删除！", 1)
                    }
                }
            })
        }
    }


    const displayPhoto = (item: any) => {
        const mPhoto = savedValue.filter((val: any) => {
            if (item.dataCode === val.dataCode) {
                return true;
            }
            return false;
        }).map((item: any) => {
            return item.value;
        });
        let diaplayPhotos = (mPhoto[0] || []).map((itemVal: any) => {
            return {
                url: itemVal
            }
        })
        let suffixPhotos = changedPhoto(diaplayPhotos);
        return (suffixPhotos && suffixPhotos.length > 0) ?
            <ImagePicker
                ref={mPhotoRef}
                filesList={suffixPhotos}
                multiple={false}
                max={8}
                mode="cover"
                width="22%"
                onGetPreviewUrl={(index) => { onReadOnlyPreview(index, suffixPhotos) }}
                config={['defaultDashed']}
                disabled={true}
            />
            :
            null
    }

    const displayVideo = (item: any) => {
        const mVideos = savedValue.filter((val: any) => {
            if (item.dataCode === val.dataCode) {
                return true;
            }
            return false;
        }).map((item: any) => {
            return item.value;
        });
        let diaplayVideos = mVideos.map((itemVal: any) => {
            return {
                url: itemVal
            }
        })
        let suffixVideos = changedPhoto(diaplayVideos);
        return (suffixVideos && suffixVideos.length > 0) ?
            <Video
                ref={mVideoRef}
                filesList={suffixVideos}
                multiple={false}
                max={1}
                mode="cover"
                width="22%"
                config={['defaultDashed']}
                disabled={true}
            />
            :
            null
    }

    //选择表单
    const switchField = (item: any, index?: any) => {
        if (item.display) {
            // ValueCascade
            if (item.display.type === 'ValueCascade') {
                // eq
                if (item.display.condition === 'eq') {
                    //当前选中表单已存的value
                    let currentItem = savedValue.find((i: any) => {
                        return i.dataCode == item.display.target
                    });
                    // console.log('switchField-item:',item,',switchField-currentItem:',currentItem)
                    if (currentItem) {
                        if ((currentItem.value && currentItem.value.indexOf(item.display.rule) !== -1) || (currentItem.value && currentItem.value === item.display.rule)) {
                            return chooseForm(item, index)
                        }
                    }
                }
                else if (item.display.condition === 'andEq') {
                    let judgeArr = [];
                    for (let i = 0; i < item.display.target.length; i++) {
                        let findedItem = savedValue.find((valueItem: any) => {
                            return valueItem.dataCode === item.display.target[i]
                        });
                        if (findedItem) {
                            if (findedItem.value instanceof Array) {
                                if (findedItem.value.indexOf(item.display.rule[i]) === -1) {
                                    judgeArr.push(false);
                                }
                                else {
                                    judgeArr.push(true);
                                }
                            }
                            else {
                                if (findedItem.value !== item.display.rule[i]) {
                                    judgeArr.push(false);
                                }
                                else {
                                    judgeArr.push(true);
                                }
                            }
                        }
                        else {
                            judgeArr.push(false)
                        }
                    }
                    if (judgeArr.every(item => {
                        if (item === true) {
                            return true
                        }
                    })) {
                        return chooseForm(item, index)
                    }
                }
                else if (item.display.condition === 'orEq') {
                    let judgeArr = [];
                    for (let i = 0; i < item.display.target.length; i++) {
                        let findedItem = savedValue.find((valueItem: any) => {
                            return valueItem.dataCode === item.display.target[i]
                        });
                        if (findedItem) {
                            if (findedItem.value instanceof Array) {
                                if (findedItem.value.indexOf(item.display.rule[i]) === -1) {
                                    judgeArr.push(false);
                                }
                                else {
                                    judgeArr.push(true);
                                }
                            }
                            else {
                                if (findedItem.value !== item.display.rule[i]) {
                                    judgeArr.push(false);
                                }
                                else {
                                    judgeArr.push(true);
                                }
                            }
                        }
                        else {
                            judgeArr.push(false)
                        }
                    }
                    if (judgeArr.indexOf(true) !== -1) {
                        return chooseForm(item, index)
                    }
                }
            }
        }
        else {
            return chooseForm(item, index)
        }
    }

    //根据表单类型选择相应表单
    const chooseForm = (item: any, index?: any) => {
        let radiosArr = [];
        let _optional = item.optional;
        for (let key in _optional) {
            radiosArr.push({
                value: key,
                label: _optional[key]
            });
        }
        const type = item.type;
        switch (type) {
            //选择
            case 'select':
                return (
                    <>
                        {/* <div className="content" onClick={fillFormBtn(item)}> */}
                        <div className="content">
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>

                            {/* {
                                false 
                            } */}
                            {/* <div className="field_right">
                                <span className="defaultValue">
                                    {showSavedValue(item)}
                                </span>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoFill} alt="前往表单操作" /> : null
                                }
                            </div> */}

                        </div>
                        <div className={styless.select_wrap}>
                            <V5Radio.Group
                                defaultValue={item.selectedValue?.value}
                                value={item.selectedValue?.value}
                                onChange={val => {
                                    updateFormValue(item, val, null);
                                }}
                            >
                                <Space direction='vertical'>
                                    {
                                        radiosArr && radiosArr.map((val: any, key) => {
                                            return (
                                                <V5Radio value={val.value} >{val.label}</V5Radio>
                                            )
                                        })
                                    }

                                </Space>
                            </V5Radio.Group>
                            {
                                // 其他
                                item.selectedValue && item.selectedValue && item.selectedValue.value && item.optional[item.selectedValue.value] && (item.optional[item.selectedValue.value].indexOf('其他') === 0) &&
                                // item.selectedValue && item.selectedValue && item.selectedValue.value && item.selectedOtherValue && item.selectedOtherValue.value && 
                                <div className={styless.others_content}>
                                    <TextArea
                                        placeholder='请输入（其他）内容'
                                        value={item.selectedOtherValue?.value}
                                        rows={2}
                                        showCount={false}
                                        onChange={val => {
                                            updateFormValue(item, null, val);
                                        }}
                                    />
                                </div>
                            }
                        </div>
                    </>
                )
            //只读文本
            case 'text':
                let _answeredNum = 0;
                let _totalNum = 0;
                let _children = [];
                let _index = 0;
                // 找到当前条目对应的最外层那一层数据数据
                (fieldList[0].children || []).some((outerValue: any, ouerIndex: number) => {
                    let isEnd = (outerValue.children || []).some((innerValue: any, innerIndex: number) => {
                        if (innerValue.dataCode = item.dataCode) {
                            _index = ouerIndex;
                            return true;
                        }
                    });
                    return isEnd;
                });
                _children = fieldList[0].children[_index] || [];
                let _childChildren = _children.children || [];
                _childChildren.forEach((vv: any, index: number) => {
                    if (vv.type === 'select') {
                        _totalNum++;
                        if (vv.selectedValue) {
                            _answeredNum++;
                        }
                    }
                });
                return (
                    <>
                        <div className="content">
                            <div className="field_label text_field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>
                            {/*<div className="field_right">*/}
                            {/*    <div className="defaultValue">*/}
                            {/*        {showSavedValue(item)}*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                        <div className={styless.progress_bar_wrap}>
                            <div className={styless.progress_bar_inner}>
                                <div className={styless.progress_bg} style={{ width: (_answeredNum / _totalNum) * 100 + '%' }}></div>
                            </div>
                            <div className={styless.number_progress}>
                                <span className={styless.current}>{_answeredNum}</span>/{_totalNum}
                            </div>
                        </div>
                    </>
                )
            // 拍照备注
            case 'photo-remark':
                return (
                    formIsRead ? (
                        <>
                            <div className="content" onClick={showPhotoRemark(item)}>
                                <div className="field_label field_label_remark">
                                    {validationIsNull(item)}
                                    {item.label}
                                </div>
                                <>{renderAnswer(item)}</>
                                {
                                    props.readonly != true &&
                                    <div className="field_right">
                                        <div className="defaultValue">查看示例</div>
                                        <img src={formGoFill} alt="前往表单操作" />
                                    </div>
                                }
                            </div>
                            <ImageViewer
                                image={item["link"]}
                                visible={item["link"] === currPhotoRemark}
                                onClose={() => {
                                    setCurrPhotoRemark("")
                                }}
                            />
                        </>
                    ) : <></>
                )
            //输入框
            case 'input':
                return (
                    <>
                        <div className="content" onClick={fillFormBtn(item)}>
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>

                            <div className="field_right">
                                <div className="defaultValue">
                                    {showSavedValue(item)}
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoFill} alt="前往表单操作" /> : null
                                }
                            </div>

                        </div>
                    </>
                )
            //输入框
            case 'number':
                return (
                    <>
                        <div className="content" onClick={fillFormBtn(item)}>
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    {showSavedValue(item)}
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoFill} alt="前往表单操作" /> : null
                                }
                            </div>
                        </div>
                    </>
                )
            //时间表单
            case 'date':
                return (
                    <>
                        <div className="content" onClick={fillFormBtn(item)}>
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    {showSavedValue(item)}
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoFill} alt="前往表单操作" /> : null
                                }
                            </div>
                        </div>
                    </>
                )
            //文本域
            case 'textarea':
                return (
                    <>
                        <div className="content" onClick={fillFormBtn(item)}>
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    {showSavedValue(item)}
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoFill} alt="前往表单操作" /> : null
                                }
                            </div>
                        </div>
                    </>
                )
            //photo
            case 'photo':
            case 'photo-oss':
                let renderPhoto = null;
                if (props.readonly) {
                    renderPhoto = displayPhoto(item);
                }
                return (
                    <>
                        <div className={`content ${renderPhoto ? 'content_has_photo' : ''}`} onClick={fillFormBtn(item)}>
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    {showSavedValue(item)}
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoPhoto} alt="前往拍照上传" /> : null
                                }
                            </div>
                        </div>
                        {
                            props.readonly && renderPhoto &&
                            <div style={{ marginTop: '5px', borderBottom: '1px solid #D8D8D8' }}>
                                {renderPhoto}
                            </div>
                        }
                    </>
                )
            // video
            case 'video':
                let renderVideo = null;
                if (props.readonly) {
                    renderVideo = displayVideo(item);
                }
                return (
                    <>
                        <div className={`content ${renderVideo ? 'content_has_video' : ''}`} onClick={fillFormBtn(item)}>
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    {showSavedValue(item)}
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoPhoto} alt="前往上传视频" /> : null
                                }
                            </div>
                        </div>
                        {
                            props.readonly && renderVideo &&
                            <div style={{ marginTop: '5px' }}>
                                {renderVideo}
                            </div>
                        }
                    </>
                )
            // file
            case 'file':
                return (
                    <>
                        <div className="content" onClick={fillFormBtn(item)}>
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    {showSavedValue(item)}
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoPhoto} alt="前往上传文件" /> : null
                                }
                            </div>
                        </div>
                    </>
                )
            //checkbox
            case 'checkbox':
                return (
                    <>
                        <div className="content" onClick={fillFormBtn(item)}>
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    {showSavedValue(item)}
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoFill} alt="前往表单操作" /> : null
                                }
                            </div>
                        </div>
                    </>
                )
            //input-select
            case 'input-select':
                return (
                    <>
                        <div className="content" onClick={fillFormBtn(item)}>
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    {showSavedValue(item)}
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoFill} alt="前往表单操作" /> : null
                                }
                            </div>
                        </div>
                    </>
                )
            //decimal
            case 'decimal':
                return (
                    <>
                        <div className="content" onClick={fillFormBtn(item)}>
                            <div className="field_label">
                                {validationIsNull(item)}
                                {item.label}
                            </div>
                            <>{renderAnswer(item)}</>
                            <div className="field_right">
                                <div className="defaultValue">
                                    {showSavedValue(item)}
                                </div>
                                {
                                    props.readonly != true && formIsRead ? <img src={formGoFill} alt="前往表单操作" /> : null
                                }
                            </div>
                        </div>
                    </>
                )
            //多个表单组
            case 'group':
                return (
                    <React.Fragment>
                        {item.label ? <div className="title">
                            &ensp;{item.label}
                        </div> : null}
                        {
                            item.children.map((field: any, i: any) => {
                                let renderDom = switchField(field, i);
                                return (
                                    <>
                                        {
                                            renderDom ?
                                                <div className="field" key={i}>
                                                    {renderDom}
                                                </div>
                                                :
                                                null
                                        }
                                    </>

                                )
                            })
                        }
                    </React.Fragment>
                )
            //list类型
            case 'list':
                return (
                    <React.Fragment>
                        {item.label ? <div className="title">
                            &ensp;{item.label}
                        </div> : null}
                        <div className={`list#${index}`}>
                            {
                                item.children.map((field: any, i: any) => {
                                    return (
                                        <div style={{ width: '100%' }} key={i}>
                                            <div style={{ width: '100%', display: 'flex', alignItems: 'baseline' }}>
                                                {
                                                    item.children.length >= 1 ? <Badge style={{ backgroundColor: '#6287EC', color: '#ffffff' }} text={i + 1} overflowCount={item.maxNumber} /> : null
                                                }
                                                {
                                                    isShowDelete(i, item)
                                                }
                                            </div>
                                            {switchField(field)}
                                        </div>
                                    )
                                })
                            }
                        </div>
                        {
                            isAddMore(item)
                        }
                    </React.Fragment>
                )
            default:
                break;
        }
    }

    //验证输入规则是否符合正则标准
    const checkInputFormat = (value: any, selectField: any) => {
        if (verify.checkValueByRep(value, selectField)) {
            setInputError(false)
        } else {
            setInputError(true)
        }
    }

    //选择表单具体元素
    const switchForm = () => {
        //录入权限 || 修改权限
        if (selectNoteType === 'DataActionInput' || selectNoteType === 'DataActionUpdate') {
            if (selectField) {
                const type = selectField.type;
                switch (type) {
                    //输入框
                    case 'input':
                        return (
                            <div style={{ border: inputError ? '1px solid red' : '' }} className={selectField.unit ? 'field_flex' : 'field_form'}>
                                <InputItem
                                    id="input"
                                    clear
                                    placeholder={`请输入${selectField.label}`}
                                    onChange={(value) => { setCurrentValue(value); checkInputFormat(value, selectField) }}
                                    error={inputError}
                                    onErrorClick={() => { Toast.info('请输入正确格式！'); }}
                                    value={currentValue}
                                    autoFocus={true}
                                ></InputItem>
                                {/* 单位 */}
                                {
                                    selectField.unit ? <span className="field_unit">{selectField.unit}</span> : null
                                }
                            </div>
                        )
                    //时间选择器
                    case 'date':
                        let maxDate;
                        let minDate;
                        if (selectField.validationRules && selectField.validationRules.length > 0) {
                            for (let item of selectField.validationRules) {
                                if (item.type === 'range') {
                                    if (item.condition === 'lte') {
                                        if (item.rule === '${currDate}') {
                                            maxDate = new Date();
                                        } else {
                                            maxDate = new Date(item.rule);
                                            console.log(item.rule);
                                        }
                                    }
                                    else if (item.condition === 'gte') {
                                        if (item.rule === '${currDate}') {
                                            minDate = new Date();
                                        } else {
                                            minDate = new Date(item.rule);
                                            console.log(item.rule);
                                        }
                                    }
                                } else if (item.type === 'compare') {
                                    if (savedValue && savedValue.length > 0) {
                                        let compareData;
                                        for (let value of savedValue) {
                                            if (item.rule === value["dataCode"]) {
                                                compareData = value["value"];
                                            }
                                        }
                                        if (compareData && item.condition === 'lte') {
                                            maxDate = new Date(compareData);
                                        } else if (compareData && item.condition === 'gte') {
                                            minDate = new Date(compareData);
                                        }
                                    }
                                }
                            }
                        }

                        return (
                            <div className="field_noFlex">
                                <DatePickerView
                                    mode="date"
                                    value={currentValue ? new Date(currentValue) : new Date()}
                                    maxDate={maxDate}
                                    minDate={minDate ? minDate : new Date(1920, 0, 1)}
                                    onChange={(value) => { setCurrentValue(value) }}
                                />
                            </div>
                        )
                    //选择
                    case 'select':
                        let selectFilterArr = [];
                        for (let optionItem of Object.keys(selectField.optional)) {
                            selectFilterArr.push(
                                {
                                    label: selectField.optional[optionItem],
                                    value: optionItem
                                }
                            )
                        }
                        return (
                            <div className="field_noFlex">
                                {
                                    selectFilterArr.length > 0 && selectFilterArr.map((item: any, index: any) => (
                                        <RadioItem key={index} checked={item.value === currentValue} onClick={onClickSelect(item.value)}>
                                            {item.label}
                                        </RadioItem>
                                    ))
                                }
                                {
                                    switchOtherField()
                                }
                            </div>
                        )
                    //checkbox
                    case 'checkbox':
                        let checkboxFilterArr = [];
                        for (let optionItem of Object.keys(selectField.optional)) {
                            checkboxFilterArr.push(
                                {
                                    label: selectField.optional[optionItem],
                                    value: optionItem,
                                    checked: currentValue && currentValue.indexOf(optionItem) !== -1 ? true : false
                                }
                            )
                        }
                        // console.log('checkboxFilterArr:',checkboxFilterArr,',currentValue:',currentValue)
                        return (
                            <div className="field_noFlex">
                                {
                                    checkboxFilterArr.length > 0 && checkboxFilterArr.map((item: any, index: any) => (
                                        <CheckboxItem checked={item.checked} key={index} onClick={onClickCheckbox(item.value)}>
                                            {item.label}
                                        </CheckboxItem>
                                    ))
                                }
                                {
                                    switchOtherField()
                                }
                            </div>
                        )
                    //文本域
                    case 'textarea':
                        return (
                            <div className="field_noFlex">
                                <TextareaItem
                                    id="input"
                                    rows={3}
                                    count={1000}
                                    clear
                                    placeholder={`请输入${selectField.label}`}
                                    value={currentValue}
                                    onChange={(value) => { setCurrentValue(value) }}
                                    autoFocus={true}
                                ></TextareaItem>
                            </div>
                        )
                    //数字输入
                    case 'number':
                        return (
                            <div className="field_form">
                                <InputItem
                                    id="input"
                                    type="number"
                                    clear
                                    placeholder={`请输入${selectField.label}`}
                                    onChange={(value) => { setCurrentValue(verify.checkValue(value, selectField)) }}
                                    value={currentValue}
                                    autoFocus={true}
                                ></InputItem>
                                {/* 单位 */}
                                {
                                    selectField.unit ? <span className="field_unit">{selectField.unit}</span> : null
                                }
                            </div>
                        )
                    //photo
                    case 'photo':
                        case 'photo-oss':
                        return (
                            <div style={{ marginTop: '20px' }}>
                                <ImagePicker
                                    ref={mPhotoRef}
                                    filesList={infoPhotos.length > 0 ? infoPhotos : photos}
                                    onChange={onPhotoChange}
                                    multiple={false}
                                    max={8}
                                    mode="cover"
                                    onUpload={onUpload}
                                    width="22%"
                                    onGetPreviewUrl={onGetPreviewUrl}
                                    onFail={() => { Toast.fail('上传失败！', 1) }}
                                    config={['defaultDashed']}
                                    disabled={false}
                                    onDelete={onPhotoDelete}
                                />
                            </div>
                        )
                    // video
                    case 'video':
                        return (
                            <div style={{ marginTop: '20px' }}>
                                <Video
                                    ref={mVideoRef}
                                    filesList={videos}
                                    onChange={onVideoChange}
                                    multiple={false}
                                    max={1}
                                    mode="cover"
                                    onUpload={onVideoUpload}
                                    width="22%"
                                    // onGetPreviewUrl={onGetVideoPreviewUrl}
                                    onFail={() => { Toast.fail('上传失败！', 1) }}
                                    config={['defaultDashed']}
                                    disabled={false}
                                    onDelete={onVideoDelete}
                                />
                                {vedioProgress && vedioProgress.pre && (
                                    <div>
                                        <div>离开页面会导致上传失败，请耐心等待上传完成</div>
                                        <div className={"item"}>剩余时间：{vedioProgress.timer}</div>
                                        <div className={"item"}>上传进度：{vedioProgress.pre}</div>
                                        <div className={"item"}>上传速度：{vedioProgress.rt}</div>
                                    </div>
                                )}
                            </div>
                        )
                    case 'file':
                        return (
                            <div style={{ marginTop: '20px' }}>
                                <FileComponent
                                    ref={mFileRef}
                                    filesList={filesData}
                                    onChange={onFileChange}
                                    multiple={false}
                                    max={8}
                                    mode="cover"
                                    onUpload={onFileUpload}
                                    width="22%"
                                    // onGetPreviewUrl={onGetFilePreviewUrl}
                                    onFail={() => { Toast.fail('上传失败！', 1) }}
                                    config={['defaultDashed']}
                                    disabled={false}
                                    onDelete={onFileDelete}
                                />
                            </div>
                        )
                    //输入加选择:input-select
                    case 'input-select':
                        let inputSelectFilterArr = [];
                        for (let optionItem of Object.keys(selectField.optional)) {
                            inputSelectFilterArr.push(
                                {
                                    label: selectField.optional[optionItem],
                                    value: optionItem
                                }
                            )
                        }
                        return (
                            <div>
                                <div className="field_form">
                                    <InputItem
                                        id="input"
                                        clear
                                        placeholder={`请输入${selectField.label}`}
                                        onChange={(value) => { setInputValue(verify.checkValue(value, selectField)) }}
                                        value={inputValue}
                                        autoFocus={true}
                                    ></InputItem>
                                </div>
                                <div className="field_noFlex">
                                    {
                                        inputSelectFilterArr.length > 0 && inputSelectFilterArr.map((item: any, index: any) => (
                                            <RadioItem key={index} checked={item.value === selectValue} onClick={() => { setSelectValue(item.value) }}>
                                                {item.label}
                                            </RadioItem>
                                        ))
                                    }
                                    {
                                        switchOtherField()
                                    }
                                </div>
                            </div>
                        )
                    case 'decimal':
                        return (
                            <div className="field_form">
                                <InputItem
                                    id="input"
                                    clear
                                    placeholder={`请输入${selectField.label}`}
                                    onChange={(value) => { setCurrentValue(verify.checkValue(value, selectField)) }}
                                    value={currentValue}
                                    autoFocus={true}
                                ></InputItem>
                                {/* 单位 */}
                                {
                                    selectField.unit ? <span className="field_unit">{selectField.unit}</span> : null
                                }
                            </div>
                        )
                    default:
                        break;
                }
            }
        }
        //注释权限
        else if (selectNoteType === 'DataActionAnnotation') {
            return (
                <React.Fragment>
                    {
                        annotationType && annotationType.length > 0 ? < div className="field_noFlex">
                            {annotationType.map((item: any, index: any) => (
                                <RadioItem key={index} checked={item.key === annotationValue} onClick={onAnnotationChange(item.key)}>
                                    {item.text}
                                </RadioItem>
                            ))}
                        </div> : null
                    }
                </React.Fragment >
            )
        }
        // 注释只读
        else if (selectNoteType === 'DataActionAnnotationRead') {
            return (
                <React.Fragment>
                    {
                        annotationType && annotationType.length > 0 ? < div className="field_noFlex">
                            {annotationType.map((item: any, index: any) => (
                                <RadioItem key={index} checked={item.key === annotationValue} onClick={onAnnotationChange(item.key)} disabled={true}>
                                    {item.text}
                                </RadioItem>
                            ))}
                        </div> : null
                    }
                </React.Fragment >
            )
        }
        //备注权限
        else if (selectNoteType === 'DataActionRemark') {
            return (
                <div className="field_noFlex">
                    <TextareaItem
                        id="input"
                        rows={3}
                        count={1000}
                        clear
                        placeholder={`请输入备注信息`}
                        value={remarkValue}
                        onChange={(value) => { setRemarkValue(value) }}
                        autoFocus={true}
                    ></TextareaItem>
                </div>
            )
        }
        //只读权限
        else if (selectNoteType === 'DataActionRead') {
            if (selectField) {
                const type = selectField.type;
                switch (type) {
                    //输入框
                    case 'input':
                        return (
                            <div className={selectField.unit ? 'field_flex' : 'field_form'}>
                                <InputItem
                                    id="input"
                                    clear
                                    placeholder={`请输入${selectField.label}`}
                                    onChange={(value) => { setCurrentValue(value) }}
                                    value={currentValue}
                                    autoFocus={true}
                                    disabled={true}
                                ></InputItem>
                                {/* 单位 */}
                                {
                                    selectField.unit ? <span className="field_unit">{selectField.unit}</span> : null
                                }
                            </div>
                        )
                    //时间选择器
                    case 'date':
                        return (
                            <div className="field_noFlex">
                                <DatePickerView
                                    mode="date"
                                    value={currentValue ? new Date(currentValue) : new Date()}
                                    // maxDate={new Date()}
                                    minDate={new Date(1980, 0, 1)}
                                    onChange={(value) => { setCurrentValue(value) }}
                                    disabled={true}
                                />
                            </div>
                        )
                    //选择
                    case 'select':
                        let selectFilterArr = [];
                        for (let optionItem of Object.keys(selectField.optional)) {
                            selectFilterArr.push(
                                {
                                    label: selectField.optional[optionItem],
                                    value: optionItem
                                }
                            )
                        }
                        return (
                            <div className="field_noFlex">
                                {
                                    selectFilterArr.length > 0 && selectFilterArr.map((item: any, index: any) => (
                                        <RadioItem key={index} checked={item.value === currentValue} onClick={onClickSelect(item.value)} disabled={true}>
                                            {item.label}
                                        </RadioItem>
                                    ))
                                }
                                {
                                    switchOtherField()
                                }
                            </div>
                        )
                    //checkbox
                    case 'checkbox':
                        let checkboxFilterArr = [];
                        for (let optionItem of Object.keys(selectField.optional)) {
                            checkboxFilterArr.push(
                                {
                                    label: selectField.optional[optionItem],
                                    value: optionItem,
                                    checked: currentValue && currentValue.indexOf(optionItem) !== -1 ? true : false
                                }
                            )
                        }
                        return (
                            <div className="field_noFlex">
                                {
                                    checkboxFilterArr.length > 0 && checkboxFilterArr.map((item: any, index: any) => (
                                        <CheckboxItem checked={item.checked} key={index} onClick={onClickCheckbox(item.value)} disabled={true}>
                                            {item.label}
                                        </CheckboxItem>
                                    ))
                                }
                                {
                                    switchOtherField()
                                }
                            </div>
                        )
                    //文本域
                    case 'textarea':
                        return (
                            <div className="field_noFlex">
                                <TextareaItem
                                    id="input"
                                    rows={3}
                                    count={1000}
                                    clear
                                    placeholder={`请输入${selectField.label}`}
                                    value={currentValue}
                                    onChange={(value) => { setCurrentValue(value) }}
                                    autoFocus={true}
                                    disabled={true}
                                ></TextareaItem>
                            </div>
                        )
                    //数字输入
                    case 'number':
                        return (
                            <div className="field_form">
                                <InputItem
                                    id="input"
                                    type="number"
                                    clear
                                    placeholder={`请输入${selectField.label}`}
                                    onChange={(value) => { setInputValue(verify.checkValue(value, selectField)) }}
                                    value={currentValue}
                                    autoFocus={true}
                                    disabled={true}
                                ></InputItem>
                                {/* 单位 */}
                                {
                                    selectField.unit ? <span className="field_unit">{selectField.unit}</span> : null
                                }
                            </div>
                        )
                    //小数字输入
                    case 'decimal':
                        return (
                            <div className="field_form">
                                <InputItem
                                    id="input"
                                    clear
                                    placeholder={`请输入${selectField.label}`}
                                    onChange={(value) => { setInputValue(verify.checkValue(value, selectField)) }}
                                    value={currentValue}
                                    autoFocus={true}
                                    disabled={true}
                                ></InputItem>
                                {/* 单位 */}
                                {
                                    selectField.unit ? <span className="field_unit">{selectField.unit}</span> : null
                                }
                            </div>
                        )
                    //photo
                    case 'photo':
                    case 'photo-oss':
                        return (
                            <div style={{ marginTop: '20px' }}>
                                <ImagePicker
                                    filesList={photos}
                                    onChange={onPhotoChange}
                                    multiple={false}
                                    max={8}
                                    mode="cover"
                                    onUpload={onUpload}
                                    width="22%"
                                    onGetPreviewUrl={onGetPreviewUrl}
                                    onFail={() => { Toast.fail('上传失败！', 1) }}
                                    config={['defaultDashed']}
                                    disabled={true}
                                    onDelete={onPhotoDelete}
                                />
                            </div>
                        )
                    // video
                    case 'video':
                        return (
                            <div style={{ marginTop: '20px' }}>
                                <Video
                                    filesList={videos}
                                    onChange={onVideoChange}
                                    multiple={false}
                                    max={1}
                                    mode="cover"
                                    onUpload={onVideoUpload}
                                    width="22%"
                                    // onGetPreviewUrl={onGetVideoPreviewUrl}
                                    onFail={() => { Toast.fail('上传失败！', 1) }}
                                    config={['defaultDashed']}
                                    disabled={true}
                                    onDelete={onVideoDelete}
                                />
                            </div>
                        )
                    case 'file':
                        return (
                            <div style={{ marginTop: '20px' }}>
                                <FileComponent
                                    filesList={filesData}
                                    onChange={onFileChange}
                                    multiple={false}
                                    max={8}
                                    mode="cover"
                                    onUpload={onFileUpload}
                                    width="22%"
                                    // onGetPreviewUrl={onGetFilePreviewUrl}
                                    onFail={() => { Toast.fail('上传失败！', 1) }}
                                    config={['defaultDashed']}
                                    disabled={true}
                                    onDelete={onFileDelete}
                                />
                            </div>
                        )
                    //输入加选择:input-select
                    case 'input-select':
                        let inputSelectFilterArr = [];
                        for (let optionItem of Object.keys(selectField.optional)) {
                            inputSelectFilterArr.push(
                                {
                                    label: selectField.optional[optionItem],
                                    value: optionItem
                                }
                            )
                        }
                        return (
                            <div>
                                <div className="field_form">
                                    <InputItem
                                        id="input"
                                        clear
                                        placeholder={`请输入${selectField.label}`}
                                        onChange={(value) => { setInputValue(verify.checkValue(value, selectField)) }}
                                        value={inputValue}
                                        autoFocus={true}
                                        disabled={false}
                                    ></InputItem>
                                </div>
                                <div className="field_noFlex">
                                    {
                                        inputSelectFilterArr.length > 0 && inputSelectFilterArr.map((item: any, index: any) => (
                                            <RadioItem key={index} checked={item.value === selectValue} onClick={() => { setSelectValue(item.value) }} disabled={true}>
                                                {item.label}
                                            </RadioItem>
                                        ))
                                    }
                                    {
                                        switchOtherField()
                                    }
                                </div>
                            </div>
                        )
                    default:
                        break;
                }
            }
        }
        //备注只读
        else if (selectNoteType === 'DataActionRemarkRead') {
            return (
                <div className="field_noFlex">
                    <TextareaItem
                        id="input"
                        rows={3}
                        count={1000}
                        clear
                        placeholder={`请输入备注信息`}
                        value={remarkValue}
                        onChange={(value) => { setRemarkValue(value) }}
                        disabled={true}
                    ></TextareaItem>
                </div>
            )
        }
        //创建/关闭质疑
        else if (selectNoteType === 'DataActionQuestion') {
            return (
                <React.Fragment>
                    <div className="question_content">
                        <div className="questionList">
                            {
                                selectFieldQuestion && selectFieldQuestion.length > 0 && selectFieldQuestion.map((item: any, index: any) => {
                                    return (
                                        <React.Fragment key={index}>
                                            {
                                                switchQuestion(item)
                                            }
                                        </React.Fragment>
                                    )
                                })
                            }
                            {
                                !selectFieldQuestion || selectFieldQuestion.length === 0 ? <div style={{ marginTop: '10px' }}>暂无质疑</div> : null
                            }
                        </div>
                        <div className="question_title">
                            &nbsp;添加质疑
                        </div>
                        <div className="question">
                            <div className="questionForm_Item">
                                {
                                    questionType.length > 0 ?
                                        <Picker
                                            data={questionType}
                                            title="请选择检查类型"
                                            cols={1}
                                            extra="请选择(可选)"
                                            value={selectQuestionType}
                                            onOk={v => { setSelectQuestionType(v) }}
                                        >
                                            <List.Item arrow="horizontal">检查类型</List.Item>
                                        </Picker> : null
                                }
                            </div>
                            {/* <div className="questionForm_Item">
                                {
                                    questionRecipient.length > 0 ?
                                        <Picker
                                            data={questionRecipient}
                                            title="发送到"
                                            cols={1}
                                            extra="请选择(可选)"
                                            value={selectRecipient}
                                            onOk={v => { setSelectRecipient(v) }}
                                        >
                                            <List.Item arrow="horizontal">发送到</List.Item>
                                        </Picker> : null
                                }
                            </div> */}
                            <div className="questionForm_Item">
                                <TextareaItem
                                    rows={4}
                                    count={1000}
                                    clear
                                    placeholder={`请输入检查说明`}
                                    title="检查说明"
                                    value={questionInf}
                                    onChange={(value) => { setQuestionInf(value) }}
                                ></TextareaItem>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )
        }
        //回复质疑
        else if (selectNoteType === 'DataActionAnswer') {
            return (
                <React.Fragment>
                    <div className="question_content">
                        <div className="questionList">
                            {
                                selectFieldQuestion && selectFieldQuestion.length > 0 && selectFieldQuestion.map((item: any, index: any) => {
                                    return (
                                        <React.Fragment key={index}>
                                            {
                                                switchQuestion(item)
                                            }
                                        </React.Fragment>
                                    )
                                })
                            }
                            {
                                !selectFieldQuestion || selectFieldQuestion.length === 0 ? <div style={{ marginTop: '10px' }}>暂无质疑</div> : null
                            }
                        </div>
                    </div>
                </React.Fragment>
            )
        }
        //痕迹稽查
        else if (selectNoteType === 'DataActionTrace') {
            return (
                <div className="traceTable">
                    <table width="100%">
                        <thead>
                            <tr>
                                <th>操作时间</th>
                                <th>操作类型</th>
                                <th>操作后值</th>
                                <th>操作备注</th>
                                <th>操作人</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                traceList && traceList.length > 0 && traceList.map((item: any, index: any) => {
                                    return (
                                        <tr key={index}>
                                            <td>{item.operationTime}</td>
                                            <td>{item.operationTypeText}</td>
                                            <td>{item.newValue}</td>
                                            <td>{item.remark}</td>
                                            <td>{item.operator}</td>
                                        </tr>
                                    )
                                })
                            }
                            {
                                traceList.length === 0 ? <tr>
                                    <td>{'暂无'}</td>
                                    <td>{'暂无'}</td>
                                    <td>{'暂无'}</td>
                                    <td>{'暂无'}</td>
                                    <td>{'暂无'}</td>
                                </tr> : null
                            }
                        </tbody>
                    </table>
                </div>
            )
        }
    }

    //选择当有other字段时对应的表单
    const switchOtherField = () => {
        if (selectField && selectField.type === 'checkbox') {

            if (selectField.other) {
                if (currentValue && currentValue.indexOf(selectField.other.key) !== -1) {
                    let type = selectField.other.type;
                    switch (type) {
                        //input
                        case 'input':
                            return (
                                <InputItem
                                    id="input"
                                    clear
                                    placeholder={`请输入${selectField.optional[selectField.other.key]}值`}
                                    onChange={(value) => { setOtherValue(value) }}
                                    value={otherValue}
                                    autoFocus={true}
                                ></InputItem>
                            )
                            break;
                        //date
                        case 'date':
                            return (
                                <DatePickerView
                                    mode="date"
                                    value={otherValue ? new Date(otherValue) : new Date()}
                                    // maxDate={new Date()}
                                    minDate={new Date(1980, 0, 1)}
                                    onChange={(value) => { setOtherValue(value) }}
                                />
                            )
                            break;
                        default:
                            break;
                    }
                }
            }
            else {
                // return null;
                // setOtherValue(value)
            }
        }
        else if (selectField && selectField.type === 'input-select') {
            if (selectField.other) {
                if (selectValue && selectValue.indexOf(selectField.other.key) !== -1) {
                    let type = selectField.other.type;
                    switch (type) {
                        //input
                        case 'input':
                            return (
                                <InputItem
                                    id="input"
                                    clear
                                    placeholder={`请输入${selectField.optional[selectField.other.key]}值`}
                                    onChange={(value) => { setOtherValue(value) }}
                                    value={otherValue}
                                    autoFocus={true}
                                ></InputItem>
                            )
                            break;
                        //date
                        case 'date':
                            return (
                                <DatePickerView
                                    mode="date"
                                    value={otherValue ? new Date(otherValue) : new Date()}
                                    // maxDate={new Date()}
                                    minDate={new Date(1920, 0, 1)}
                                    onChange={(value) => { setOtherValue(value) }}
                                />
                            )
                            break;
                        default:
                            break;
                    }
                }
            }
            else {
                return null;
            }
        }
        else if (selectField && selectField.type === 'select') {
            if (selectField.other) {
                if (currentValue && currentValue.indexOf(selectField.other.key) !== -1) {
                    let type = selectField.other.type;
                    switch (type) {
                        //input
                        case 'input':
                            return (
                                <InputItem
                                    id="input"
                                    clear
                                    placeholder={`请输入${selectField.optional[selectField.other.key]}值`}
                                    onChange={(value) => { setOtherValue(value) }}
                                    value={otherValue}
                                    autoFocus={true}
                                ></InputItem>
                            )
                            break;
                        //date
                        case 'date':
                            return (
                                <DatePickerView
                                    mode="date"
                                    value={otherValue ? new Date(otherValue) : new Date()}
                                    // maxDate={new Date()}
                                    minDate={new Date(1920, 0, 1)}
                                    onChange={(value) => { setOtherValue(value) }}
                                />
                            )
                            break;
                        default:
                            break;
                    }
                }
            }
        }
    }

    //选择对应操作按钮
    const switchActionBtn = () => {
        if (selectNoteType) {
            switch (selectNoteType) {
                //数据只读
                case 'DataActionRead':
                    return null
                //备注只读
                case 'DataActionRemarkRead':
                    return null
                //注释只读
                case 'DataActionAnnotationRead':
                    return null
                //质疑只读
                case 'DataActionQuestionRead':
                    return null
                //录入
                case 'DataActionInput':
                    if (selectField && (
                        selectField.type === 'photo' ||
                        selectField.type === 'photo-oss' ||
                        selectField.type === 'video' ||
                        selectField.type === 'file' ||
                        selectField.type === 'select')
                    ) {
                        return null
                    }
                    else {
                        return (
                            <span onClick={onSave}>
                                <img src={saveBtn} alt="save" />
                                保存
                            </span>
                        )
                    }

                    break;
                //修改
                case 'DataActionUpdate':
                    if (selectField && (
                        selectField.type === 'photo' ||
                        selectField.type === 'photo-oss' ||
                        selectField.type === 'video' ||
                        selectField.type === 'file' ||
                        selectField.type === 'select')
                    ) {
                        return null
                    }
                    else {
                        return (
                            <span onClick={onUpdate}>
                                <img src={saveBtn} alt="save" />
                                修改
                            </span>
                        )
                    }
                    break;
                //备注
                case 'DataActionRemark':
                    return (
                        <span onClick={onRemark}>
                            <img src={saveBtn} alt="save" />
                            备注
                        </span>
                    )
                //注释
                case 'DataActionAnnotation':
                    return (
                        <span onClick={onAnnotation}>
                            <img src={saveBtn} alt="save" />
                            注释
                        </span>
                    )
                //创建/关闭质疑
                case 'DataActionQuestion':
                    return (
                        <span onClick={onQuestion}>
                            <img src={saveBtn} alt="save" />
                            添加质疑
                        </span>
                    )
                //回复质疑
                case 'DataActionAnswer':
                    return (
                        null
                    )
                //痕迹稽查
                case 'DataActionTrance':
                    return (
                        <span onClick={onTrance}>
                            <img src={saveBtn} alt="save" />
                            痕迹稽查
                        </span>
                    )
                default:
                    break;
            }
        }
    }

    //根据质疑操作类型选择不同操作
    const switchformByquestionAction = (item: any) => {
        if (item) {
            switch (item) {
                case 'Retain':
                    return (
                        <div className="form_content">
                            <div className="input_item">
                                <TextareaItem
                                    rows={2}
                                    count={1000}
                                    clear
                                    placeholder={`补充说明`}
                                    value={supplementInf}
                                    onChange={(value) => { setSupplementInf(value) }}
                                ></TextareaItem>
                            </div>
                            <div className="form_content_action">
                                <div className="cancel_btn" onClick={() => { setSelectQuestionItemId('') }}>
                                    <IconFont type="iconReject"></IconFont>取消
                                </div>
                                <div className="save_btn" onClick={onAnswerQuestion}>
                                    <IconFont type="iconSave"></IconFont>保存
                                </div>
                            </div>
                        </div>
                    )
                    break;
                case 'Update':
                    return (
                        <div className="form_content">
                            <div className="input_item">
                                <InputItem
                                    clear
                                    placeholder={`请输入修改值`}
                                    onChange={(value) => { setQuestionModifyValue(value) }}
                                    value={questionModifyValue}
                                ></InputItem>
                            </div>
                            <div className="input_item">
                                <TextareaItem
                                    rows={2}
                                    count={1000}
                                    clear
                                    placeholder={`补充说明`}
                                    value={supplementInf}
                                    onChange={(value) => { setSupplementInf(value) }}
                                ></TextareaItem>
                            </div>
                            <div className="form_content_action">
                                <div className="cancel_btn" onClick={() => { setSelectQuestionItemId('') }}>
                                    <IconFont type="iconReject"></IconFont>取消
                                </div>
                                <div className="save_btn" onClick={onAnswerQuestion}>
                                    <IconFont type="iconSave"></IconFont>保存
                                </div>
                            </div>
                        </div>
                    )
                    break;
                case 'Empty':
                    return (
                        <div className="form_content">
                            <div className="input_item">
                                <TextareaItem
                                    rows={2}
                                    count={1000}
                                    clear
                                    placeholder={`补充说明`}
                                    value={supplementInf}
                                    onChange={(value) => { setSupplementInf(value) }}
                                ></TextareaItem>
                            </div>
                            <div className="form_content_action">
                                <div className="cancel_btn" onClick={() => { setSelectQuestionItemId('') }}>
                                    <IconFont type="iconReject"></IconFont>取消
                                </div>
                                <div className="save_btn" onClick={onAnswerQuestion}>
                                    <IconFont type="iconSave"></IconFont>保存
                                </div>
                            </div>
                        </div>
                    )
                    break;
                default:
                    break;
            }
        }
    }

    //选择对应的question列表
    const switchQuestion = (item: any) => {
        const state = item.state;
        if (selectNoteType === 'DataActionAnswer') {
            switch (state) {
                //创建
                case 'Create':
                    return (
                        <div className="questionItem">
                            <div className="questionItemTop">
                                <div className="questionItem_left">
                                    <div className="questionItem_left_top">
                                        <img src={create_question} alt="质疑为回复" />
                                        <span className="question_text">{item.typeText}</span>：
                                        <span className="questionContent">{item.content}</span>
                                    </div>
                                    <div className="questionItem_left_bottom" style={{ color: '#EF8767' }}>
                                        (质疑未回复)
                                    </div>
                                </div>
                                <div className="questionItem_right">
                                    {
                                        selectQuestionItemId !== item.id ? <div className="answer_btn" style={{ border: '1px solid #6287EC' }} onClick={() => { setSelectQuestionItemId(item.id); }}>
                                            <IconFont type="iconAnswer"></IconFont>回复
                                        </div> : null
                                    }
                                </div>
                            </div>
                            {
                                selectQuestionItemId === item.id ? <div className="questionAction_content">
                                    <div className="questionAction_content_taps">
                                        {
                                            answerQuestionType.length > 0 && answerQuestionType.map((item: any, index: any) => {
                                                return (
                                                    <div style={{ background: item.value === currentQuestionType ? '#6287EC' : '#ffffff', color: item.value === currentQuestionType ? '#ffffff' : '#6287EC' }} key={index} className="questionAction_content_tapItem" onClick={() => { setCurrentQuestionType(item.value); setSupplementInf(''); setQuestionModifyValue(''); }}>{item.label}</div>
                                                )
                                            })
                                        }
                                    </div>
                                    {
                                        switchformByquestionAction(currentQuestionType)
                                    }
                                </div> : null
                            }
                        </div>
                    )
                    break;
                //重新打开
                case 'Reopen':
                    return (
                        <div className="questionItem">
                            <div className="questionItemTop">
                                <div className="questionItem_left">
                                    <div className="questionItem_left_top">
                                        <img src={create_question} alt="质疑已回复" />
                                        <span className="question_text">{item.typeText}</span>：
                                        <span className="questionContent">{item.content}</span>
                                    </div>
                                    <div className="questionItem_left_bottom" style={{ color: '#EF8767' }}>
                                        (质疑未回复)
                                    </div>
                                </div>
                                <div className="questionItem_right">
                                    {
                                        selectQuestionItemId !== item.id ? <div className="answer_btn" style={{ border: '1px solid #6287EC' }} onClick={() => { setSelectQuestionItemId(item.id) }}>
                                            <IconFont type="iconAnswer"></IconFont>回复
                                        </div> : null
                                    }
                                </div>
                            </div>
                            {
                                selectQuestionItemId === item.id ? <div className="questionAction_content">
                                    <div className="questionAction_content_taps">
                                        {
                                            answerQuestionType.length > 0 && answerQuestionType.map((item: any, index: any) => {
                                                return (
                                                    <div style={{ background: item.value === currentQuestionType ? '#6287EC' : '#ffffff', color: item.value === currentQuestionType ? '#ffffff' : '#6287EC' }} key={index} className="questionAction_content_tapItem" onClick={() => { setCurrentQuestionType(item.value); setSupplementInf(''); setQuestionModifyValue(''); }}>{item.label}</div>
                                                )
                                            })
                                        }
                                    </div>
                                    {
                                        switchformByquestionAction(currentQuestionType)
                                    }
                                </div> : null
                            }
                        </div>
                    )
                    break;
                //已回复
                case 'Answer':
                    return (
                        <div className="questionItem">
                            <div className="questionItemTop">
                                <div className="questionItem_left">
                                    <div className="questionItem_left_top">
                                        <img src={answer_question} alt="质疑为回复" />
                                        <span className="question_text">{item.typeText}</span>：
                                        <span className="questionContent">{item.content}</span>
                                    </div>
                                    <div className="questionItem_left_bottom" style={{ color: '#2A344D' }}>
                                        <img style={{ verticalAlign: 'middle' }} src={answer_question_2} alt="已修复" />
                                        已修复
                                        <span style={{ color: '#6C96F7', marginLeft: '4px' }}>回复待确认</span>
                                    </div>
                                </div>
                                <div className="questionItem_right">
                                    {
                                        selectQuestionItemId !== item.id ? <div className="answer_btn" style={{ border: '1px solid #6287EC' }} onClick={() => { setSelectQuestionItemId(item.id) }}>
                                            <img src={question_modify} alt="修改" />
                                            修改
                                        </div> : null
                                    }
                                </div>
                            </div>
                            {
                                selectQuestionItemId === item.id ? <div className="questionAction_content">
                                    <div className="questionAction_content_taps">
                                        {
                                            answerQuestionType.length > 0 && answerQuestionType.map((item: any, index: any) => {
                                                return (
                                                    <div style={{ background: item.value === currentQuestionType ? '#6287EC' : '#ffffff', color: item.value === currentQuestionType ? '#ffffff' : '#6287EC' }} key={index} className="questionAction_content_tapItem" onClick={() => { setCurrentQuestionType(item.value); setSupplementInf(''); setQuestionModifyValue(''); }}>{item.label}</div>
                                                )
                                            })
                                        }
                                    </div>
                                    {
                                        switchformByquestionAction(currentQuestionType)
                                    }
                                </div> : null
                            }
                        </div>
                    )
                    break;
                //已关闭
                case 'Closed':
                    return (
                        <div className="questionItem">
                            <div className="questionItemTop">
                                <div className="questionItem_left">
                                    <div className="questionItem_left_top">
                                        <img src={close_question} alt="" />
                                        <span className="question_text">{item.typeText}</span>：
                                        <span className="questionContent">{item.content}</span>
                                    </div>
                                    <div className="questionItem_left_bottom" style={{ color: '#2A344D' }}>
                                        <img src={close_question_2} alt="" />
                                        已修复
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                    break;

                default:
                    break;
            }
        }
        //质疑创建和关闭权限
        else if (selectNoteType === 'DataActionQuestion') {
            switch (state) {
                //创建
                case 'Create':
                    return (
                        <div className="questionItem">
                            <div className="questionItemTop">
                                <div className="questionItem_left">
                                    <div className="questionItem_left_top">
                                        <img src={create_question} alt="质疑未回复" />
                                        <span className="question_text">{item.typeText}</span>：
                                        <span className="questionContent">{item.content}</span>
                                    </div>
                                    <div className="questionItem_left_bottom" style={{ color: '#EF8767' }}>
                                        (质疑未回复)
                                    </div>
                                </div>
                                <div className="questionItem_right">
                                    <div style={{ backgroundColor: '#6287EC', border: '1px solid #6287EC', color: '#ffffff' }} className="answer_btn" onClick={closeQuestion(item.id)}>
                                        <IconFont type="iconClose"></IconFont>关闭
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                    break;
                //重新打开
                case 'Reopen':
                    return (
                        <div className="questionItem">
                            <div className="questionItemTop">
                                <div className="questionItem_left">
                                    <div className="questionItem_left_top">
                                        <img src={create_question} alt="质疑为回复" />
                                        <span className="question_text">{item.typeText}</span>：
                                        <span className="questionContent">{item.content}</span>
                                    </div>
                                    <div className="questionItem_left_bottom" style={{ color: '#EF8767' }}>
                                        (质疑未回复)
                                    </div>
                                </div>
                                <div className="questionItem_right">
                                    <div style={{ backgroundColor: '#6287EC', border: '1px solid #6287EC', color: '#ffffff' }} className="answer_btn" onClick={closeQuestion(item.id)}>
                                        <IconFont type="iconClose"></IconFont>关闭
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                    break;
                //已回复
                case 'Answer':
                    return (
                        <div className="questionItem">
                            <div className="questionItemTop">
                                <div className="questionItem_left">
                                    <div className="questionItem_left_top">
                                        <img src={answer_question} alt="质疑为回复" />
                                        <span className="question_text">{item.typeText}</span>：
                                        <span className="questionContent">{item.content}</span>
                                    </div>
                                    <div className="questionItem_left_bottom" style={{ color: '#2A344D' }}>
                                        <img style={{ verticalAlign: 'middle' }} src={answer_question_2} alt="已修复" />
                                        <span style={{ whiteSpace: 'nowrap' }}>已修复</span>
                                        <span style={{ color: '#6C96F7', marginLeft: '4px' }}>{item.answer ? item.answer.content : ''}</span>
                                    </div>
                                </div>
                                <div className="questionItem_right">
                                    <div style={{ backgroundColor: '#ffffff', border: '1px solid #6287EC', color: '#6287EC' }} className="answer_btn" onClick={reopenQuestion(item.id)}>
                                        重新打开
                                    </div>
                                    <div style={{ backgroundColor: '#6287EC', border: '1px solid #6287EC', color: '#ffffff' }} className="answer_btn" onClick={closeQuestion(item.id)}>
                                        <IconFont type="iconClose"></IconFont>关闭
                                    </div>
                                </div>
                            </div>

                        </div>
                    )
                    break;
                //已关闭
                case 'Closed':
                    return (
                        <div className="questionItem">
                            <div className="questionItemTop">
                                <div className="questionItem_left">
                                    <div className="questionItem_left_top">
                                        <img src={close_question} alt="" />
                                        <span className="question_text">{item.typeText}</span>：
                                        <span className="questionContent">{item.content}</span>
                                    </div>
                                    <div style={{ color: '#2A344D' }} className="questionItem_left_bottom">
                                        <img src={close_question_2} alt="质疑已关闭" />
                                        已修复
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                    break;

                default:
                    break;
            }
        }
    }

    // 渲染质疑
    const renderAnswer = (item: any) => {
        let currentItem = savedValue.find((i: any) => {
            return i.dataCode === item.dataCode
        });

        if (currentItem && currentItem.question) {
            let dom;
            currentItem.questions && currentItem.questions.length > 0 && currentItem.questions.map((qItem: any, qIndex: any) => {
                if (qItem.state == 'Answer') {
                    dom = <img src={IconAnswerReply} alt='' className='IconAnswer' />
                } else {
                    dom = <img src={IconAnswer} alt='' className='IconAnswer' />
                }
            })

            return dom
        }
        else {
            return <></>
        }
    }

    // 图片有缓存，需要加后缀更新
    const changedPhoto = (photos: any) => {
        photoId++;
        const urlChangePhotos = photos.map((val: Object) => {
            let _url = '';
            // @ts-ignore
            if (val.url.indexOf('?') > -1) {
                // @ts-ignore
                _url = val.url + photoId
            } else {
                // @ts-ignore
                _url = val.url + '?id=' + photoId
            }
            return {
                url: _url
            };
        });
        return urlChangePhotos;
    }

    // 敏感信息等拼接
    const getInfoTipPhoto = (photos: any) => {
        const urlChangePhotos = photos.map((val: Object, index: any) => {
            // @ts-ignore
            let _url = val.url.indexOf('?') > 0 ? val.url.split('?')[0] : val.url;
            let sensitiveInfo = matchUrlSensitive[_url] !== undefined ? "1" : "0";
            return {
                ...val,
                // @ts-ignore
                url: val.url,
                sensitiveInfo: sensitiveInfo, // "1"是敏感 "0"不是
                desensitization: isEditPhoto ? "1" : "0",// "1"是脱敏 "0"不是
                sensitiveData: matchUrlSensitive[_url]
            };
        });
        return urlChangePhotos;
    }

    // 图片有缓存，需要加后缀更新
    const filterDeletePhoto = (photos: any) => {
        const seletedPhoto = photos[currentPhotoIndex];
        let deleteIndex = 0;
        const remainUrlPhotos = photos.filter((val: Object, index: number) => {
            // @ts-ignore
            let isDeleteUrl = val.url.indexOf(seletedPhoto.url) > -1;
            if (isDeleteUrl) {
                deleteIndex = index;
            }
            // @ts-ignore
            return !isDeleteUrl;
        });

        return {
            remainPhotos: remainUrlPhotos,
            deleteIndex
        };
    }

    const updatePhoto = () => {
        let suffixPhotos = changedPhoto(photos);
        setPhotos(suffixPhotos);
        setInfoPhotos(getInfoTipPhoto(suffixPhotos));
    }

    const imgCanvasPreviewClose = (backType: String, backMsg: String, backAction: String) => {
        // @ts-ignore
        if (backMsg && (backMsg.indexOf('http') === 0)) {
            // @ts-ignore
            matchUrlSensitive[backMsg] = backMsg;
        }
        setPhotoVisible(false);
        setShowModal(true);
        if (backType === 'deleteImage' || backAction === 'deleteImage') {
            let { remainPhotos, deleteIndex } = filterDeletePhoto(photos);
            // @ts-ignore
            mPhotoRef.current.toDeletePhoto(deleteIndex);
            setPhotos(remainPhotos);
            setInfoPhotos(getInfoTipPhoto(remainPhotos));
        } else {
            updatePhoto();
        }
        // doNothing返回时，notUpdate首次进入未保存图片删除时，不需要更新入库
        if (backType !== 'doNothing' && backAction !== 'notUpdate') {
            // 保存上传提交的数据
            afterUploadSaveData();
            // 清空上传需要提交的数据
        }
        setFormUpdateParams({});
    }

    let isValidUrl = false;
    if (infoPhotos[currentPhotoIndex] && infoPhotos[currentPhotoIndex].url) {
        if (infoPhotos[currentPhotoIndex].url.indexOf('http') === 0) {
            isValidUrl = true;
        }
    }
    // console.log('fieldList:',fieldList)
    return (
        <div className="questionSurveyFormWrap" >
            {
                fieldList && fieldList.length > 0 && fieldList.map((item: any, index: any) => {
                    return (
                        <div className="questionSurveyForm" key={index}>
                            {switchField(item)}
                        </div>
                    )
                })
            }

            <Modal visible={showModal} animationType={"slide-up"}>
                {/* <div className="closeModal">
                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: selectField && selectField.label.length > 22 ? '12px' : '14px' }}>{selectField ? selectField.label : null}</div>
                    <img onClick={onCloseModal} src={close} alt="close" />
                </div> */}

                {selectField && <><div style={{ textAlign: 'left', fontSize: '16px', color: '#424347', padding: '10px', display: 'flex', lineHeight: '18px', paddingBottom: '0' }}>
                    <div style={{ width: '6px', height: '18px', background: '#6c96f7', marginRight: '4px' }}></div>
                    <div style={{ width: 'calc(100% - 12px)' }}>
                        {selectField ? selectField.label : null}
                    </div>
                </div>

                    <div className="modalContent">
                        {
                            currentFormInfo && currentFormInfo.length > 0 ? <div className="label_content">
                                {
                                    currentFormInfo.map((item: any, index: any) => {
                                        return (
                                            <span key={index}>
                                                <img src={noCollected} alt="noCollected" />{item}
                                            </span>
                                        )
                                    })
                                }
                            </div> : null
                        }
                        <div className="field_content">
                            {/* <div className="noteBtn">
                            {
                                dataAction.map((item: any, index: any) => {
                                    return (
                                        item.key == selectNoteType ? <div key={index} className="noteItem active" onClick={onClickNoteType(item.key)}>{item.label}
                                        </div> : <div key={index} className="noteItem" onClick={onClickNoteType(item.key)}>{item.label}
                                            </div>
                                    )
                                })
                            }
                        </div> */}
                            <Tabs tabs={dataAction} tabBarUnderlineStyle={{ borderColor: '#6287EC' }} tabBarBackgroundColor="transparent" tabBarInactiveTextColor="#9A9FAB" page={currentTabIndex} onChange={(tab, index) => { onChangeTab(tab, index) }} renderTab={tab => <span>{tab.label}</span>}>
                            </Tabs>
                            {
                                switchForm()
                            }
                        </div>
                        <div className="saveBtn">
                            <span onClick={() => { onCloseModal() }} style={{ marginRight: '6px', background: 'white', color: '#6287EC', border: '1px solid #6287EC' }}>
                                <IconFont style={{ padding: '0', marginRight: '4px' }} type="iconClose"></IconFont>
                                返回

                            </span>
                            {/* <span onClick={nextTopic}>{nextText}</span> */}
                            {
                                switchActionBtn()
                            }
                        </div>
                    </div>

                    <ActivityIndicator animating={loading} size={"small"} text={'正在加载数据'} toast />
                    <ActivityIndicator animating={uploadState} size={"small"} text={'图片正在上传中...'} toast />
                </>}
            </Modal>

            {/* 图片预览 */}
            {
                // !editPhoto && 
                // !ifEditPhoto && 
                // !isEditPhoto && 
                // 不需要OCR识别以及不需要脱敏
                !isOcr && !isEditPhoto &&
                <PhotoSlider
                    photoClosable
                    bannerVisible={true}
                    images={photos && photos.map((item: any) => ({ src: item.url }))}
                    visible={photoVisible}
                    onClose={() => { setPhotoVisible(false); setShowModal(true) }}
                    index={currentPhotoIndex}
                    introVisible={true}
                    onIndexChange={(i: any) => { setCurrentPhotoIndex(i) }}
                />
            }
            {
                props.readonly &&
                <PhotoSlider
                    photoClosable
                    bannerVisible={true}
                    images={photos && photos.map((item: any) => ({ src: item.url }))}
                    visible={photoVisible}
                    onClose={() => { setPhotoVisible(false); setTimeout(() => { document.body.style.overflow = 'auto'; }, 500); }}
                    index={currentPhotoIndex}
                    introVisible={true}
                    onIndexChange={(i: any) => { setCurrentPhotoIndex(i) }}
                />
            }
            {/* 脱敏预览 */}
            {
                // 需要OCR识别或者脱敏
                // editPhoto && photoVisible && 
                // ifEditPhoto && photoVisible && 
                // isEditPhoto && photoVisible && isValidUrl &&
                (isOcr || isEditPhoto) && photoVisible && isValidUrl &&
                <ImgCanvas
                    isOcr={isOcr}
                    isEditPhoto={isEditPhoto}
                    needOcrRecongize={needOcrRecongize}
                    itemData={itemData}
                    sensitiveData={sensitiveData[currentPhotoIndex]}
                    photos={photos}
                    fieldList={fieldList}
                    selectField={selectField}
                    formCode={formCode}
                    version={version}
                    formId={formId}
                    imgUrl={infoPhotos[currentPhotoIndex]}
                    onClose={(backType: String, backMsg: String, backAction: String) => { imgCanvasPreviewClose(backType, backMsg, backAction); }}
                />
            }
            {/* <div style={{ display: photoVisible? '' : 'none' }}>
                <ImgCanvas
                    photoVisible={photoVisible}
                    photos={photos}
                    imgUrl={photos[currentPhotoIndex]}
                    onClose={() => { setPhotoVisible(false); setShowModal(true) }}
                />
            </div> */}
        </div>
    )
}

export default forwardRef(QuestionSurveyForm);